import { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import RecModal from "../../../components/Modal/RecModal";
import ApModal from "../../../components/Modal/ApModal";
import ItemModal from "../../../components/Modal/ItemModal";
import DeposModal from "../../../components/Modal/DeposModal";
import WtaxModal from "../../../components/Modal/WtaxModal";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { payMasterModel } from "../../../../model/Purchase/PayMasterModel";
import { payDetailModel } from "../../../../model/Purchase/PayDetailModel";

// Utils
import {
  getData,
  getDataWithComp,
  getByDocId,
  getByPayId,
  getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  updateStatusByNo,
  deleteData,
  updateQty,
  insertData,
  updateData,
  getViewPoH,
  getSpRunNumber,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
  formatDate,
} from "../../../../utils/DateUtils";
import PoModal from "../../../components/Modal/PoModal";

function Form({ callInitialize, mode, setMode, name, maxPayNo, getReport }) {
  const [formMasterList, setFormMasterList] = useState([payMasterModel()]);
  const [formDetailList, setFormDetailList] = useState([]);
  const [recDataList, setRecDataList] = useState([]);
  const [poDataList, setPoDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [deposDataList, setDeposDataList] = useState([]);
  const [docRef, setDocRef] = useState("");
  const [Ref_PAY_ID, setRef_PAY_ID] = useState();

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);

  const [FinalTotal, setFinalTotal] = useState(0);
  const [disTotal, setDisTotal] = useState(0);
  const [inputValuedisTotal, setInputValuedisTotal] = useState("0.00");

  const [outstandingBalance, setOutstandingBalance] = useState(0);

  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);
  const [totalWT, setTotalWT] = useState(0);
  const [inputValueTotalWT, setInputValueTotalWT] = useState("0.00");

  const [selectedOption, setSelectedOption] = useState(1);
  const currentDate = moment().format("YYYY/MM/DD");
  const [taxData, setTaxData] = useState([
    {
      id: 1,
      type: 5,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
    {
      id: 2,
      type: 6,
      percent: 3.0,
      date: currentDate,
      amount: 0.0,
      tax: 0.0,
      remark: "",
    },
  ]);

  const [taxtotalAmount, setTaxtotalAmount] = useState(0);

  // การใช้ Tab เพื่อเปลี่ยน Form
  const [activeTab, setActiveTab] = useState("summary");

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");

  // ใช้สำหรับการ Rendered Form ต่างๆ
  const [docRefType, setDocRefType] = useState("1");
  const [deptDataList, setDeptDataList] = useState([]);
  const [selectedDeptInModal, setSelectedDeptInModal] = useState(null);

  // ใช้สำหรับการทำเรื่องจ่ายเป็นงวด
  const [paymentStatus, setPaymentStatus] = useState("oneTime"); // สถานะการจ่าย (จ่ายครั้งเดียว หรือ จ่ายเป็นงวด)
  const [installmentCount, setInstallmentCount] = useState(1); // จำนวนงวด

  // ใช้สำหรับเก็บสถานะที่มาจากการทำใบจ่ายเพิ่มเติม
  const [isPayContinue, setIsPayContinue] = useState(false);

  const [base64Image, setBase64Image] = useState("");

  // สำหรับจ่ายล่วงหน้า
  const [payBefore, setPayBefore] = useState(0);
  const [isPayBefore, setIsPayBefore] = useState(false);

  // สำหรับเก็บเลขใบสั่งซื้อ
  const [docNoPo, setDocNoPo] = useState("");

  const truncateTo2Decimals = (num) => parseCurrency(num * 100) / 100;

  function truncateToTwoDecimals(num) {
    return Math.floor(num * 100) / 100;
  }

  const getDeptFromItem = (row) => {
    if (!row || typeof row !== "object") return null;
    if (row.Emp_Dept !== undefined && row.Emp_Dept !== null) return row.Emp_Dept;
    if (row.empDept !== undefined && row.empDept !== null) return row.empDept;
    if (row.Dept_Id !== undefined && row.Dept_Id !== null) return row.Dept_Id;
    if (row.DeptId !== undefined && row.DeptId !== null) return row.DeptId;
    for (const k of Object.keys(row)) {
      if (/dept/i.test(k)) {
        const v = row[k];
        if (v !== undefined && v !== null && v !== "") return v;
      }
    }
    return null;
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // ดึงข้อมูลทั้งหมดจาก API_0301_REC_H และจัดเรียงตาม Rec_No
      const recDataList = await getDataWithComp("API_0301_REC_H", "");
      if (recDataList && recDataList.length > 0) {
        // สร้างรายการ Rec_No จาก recDataList
        const recNos = recDataList.map((record) => record.Rec_No);

        // ดึงข้อมูลจาก REC_H โดยใช้ Rec_No ที่ได้จาก API_0301_REC_H
        // และกรองตาม Rec_Status = 2 และ Doc_Status_Paid <> 2 หรือเป็น NULL
        const recHFilterQuery = `
                    AND Rec_Status = 2
                    AND (Doc_Status_Paid IS NULL OR Doc_Status_Paid <> '2')
                    AND Rec_No IN (${recNos.map((no) => `'${no}'`).join(", ")})
                `;
        const recHFiltered = await getDataWithComp("REC_H", recHFilterQuery);

        // สร้างชุด Rec_No ที่ผ่านการกรองจาก REC_H
        const filteredRecNos = new Set(
          recHFiltered.map((record) => record.Rec_No)
        );

        // กรอง recDataList ตาม Rec_No ที่ผ่านการกรอง
        const filteredRecDataList = recDataList.filter((record) =>
          filteredRecNos.has(record.Rec_No)
        );

        // จัดเรียงข้อมูลตาม Rec_No ในลำดับ DESC
        filteredRecDataList.sort((a, b) => b.Rec_No.localeCompare(a.Rec_No));

        // ตั้งค่าผลลัพธ์ที่กรองและจัดเรียงแล้ว
        setRecDataList(filteredRecDataList);
      }

      const poDataList = await getViewPoH();
      if (poDataList && poDataList.length > 0) {
        setPoDataList(poDataList.filter((po) => po.Doc_Status_PaidName === "-"));
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
        setRef_PAY_ID(maxPayNo);
        setDocRef(maxPayNo);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      // ดึงข้อมูลแผนกสำหรับใช้เลือกแผนกเมื่อเป็นจ่ายเฉพาะรายการ
      try {
        const deptResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-tb-set-dept`,
          {},
          { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
        );
        if (deptResponse.data && deptResponse.data.length > 0) {
          setDeptDataList(deptResponse.data);
        }
      } catch (err) {
        // ignore dept fetch error for now
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const deposDataList = await getDataWithComp(
        "API_0501_DEPOS_H",
        `AND DocStatus_Name = 'จ่ายมัดจำแล้ว' ORDER BY Doc_No DESC`
      );
      if (deposDataList && deposDataList.length > 0) {
        setDeposDataList(deposDataList);
      }

      setPayBefore(0);
      setIsPayBefore(false);

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList, arDataList, recDataList, poDataList);

        const findIdByNo = await getDataWithComp(
          "PAY_H",
          `AND Pay_No = '${maxPayNo}'`
        );

        if (findIdByNo[0].Pay_Id) {
          const image = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 4 AND Doc_ID = ${findIdByNo[0].Pay_Id}`
          );

          if (Array.isArray(image) && image.length > 0) {
            setSelectedFiles(image);
          } else {
            setSelectedFiles([]);
          }
        } else {
          setSelectedFiles([]);
        }

        // ค้นหาไฟล์ที่เกี่ยวข้อง
        if (findIdByNo[0].Pay_Type === 1) {
          const getDetailForRec = await getData(
            "PAY_D",
            `Pay_Id = ${findIdByNo[0].Pay_Id}`
          );
          if (getDetailForRec && getDetailForRec.length > 0) {
            const image = await getDataWithComp(
              "Upload_File_List",
              `AND DocCode_ID = 3 AND Doc_ID = ${getDetailForRec[0].Rec_Id}`
            );
            if (Array.isArray(image) && image.length > 0) {
              setSelectedRecFiles(image);
            } else {
              setSelectedRecFiles([]);
            }
          }
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (apDataList, arDataList, recDataList, poDataList) => {
    try {
      // ค้นหาข้อมูลที่ตรงกับใน AP_ID ใน apDataList
      const findMaster = await getDataWithComp("PAY_H", "");
      const fromDatabase = findMaster.find((pay) => pay.Pay_No === maxPayNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายหรือลูกค้าด้วย ID ที่เกี่ยวข้อง
      let fromViewAp, fromViewAr;
      if (fromDatabase.Pay_Type === 3) {
        fromViewAr = arDataList.find((ar) => ar.AR_Id === fromDatabase.AR_Id);
        if (!fromViewAr) {
          throw new Error("ไม่พบข้อมูลลูกค้า");
        }
      } else {
        fromViewAp = apDataList.find((ap) => ap.AP_Id === fromDatabase.AP_Id);
        if (!fromViewAp) {
          throw new Error("ไม่พบข้อมูลผู้ขาย");
        }
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0401_PAY_H", "");
      const fromView = findViewMaster.find((data) => data.Pay_No === maxPayNo);

      if (fromView) {
        setStatusName(fromView.PayStatus_Name);
        setStatusColour(fromView.PayStatus_Colour);
        setSelectedDiscountValueType(
          fromView?.Discount_Value_Type === 1 ? "1" : "2"
        );
      }

      // ค้นหาประเภทการจ่ายหลังอนุมัติแล้ว
      if (parseCurrency(fromView.Pay_Status) === 2) {
        const findPayHistory = await getData(
          "Pay_History",
          `DocCode_Id = 4 AND Doc_Id = ${fromDatabase.Pay_Id}`
        );

        if (findPayHistory && findPayHistory.length > 0) {
          if (findPayHistory.length > 1) {
            setStatusPaidTypeName("จ่ายหลายช่องทาง");
            setStatusPaidTypeColour("#8A3707");
          } else {
            switch (findPayHistory[0].Pay_Type) {
              case 1:
                setStatusPaidTypeName("เงินสด");
                setStatusPaidTypeColour("#13A10E");
                break;
              case 2:
                setStatusPaidTypeName("เงินโอน");
                setStatusPaidTypeColour("#0F6CBD");
                break;
              case 3:
                setStatusPaidTypeName("เช็ค");
                setStatusPaidTypeColour("#BD0F77");
                break;
              default:
                break;
            }
          }
        }
      }

      handleChangePayType(String(fromDatabase.Pay_Type));

      if (fromDatabase.IsVat === 1) {
        setIsVatChecked(true);
      }
      const getWtaxHResponse = await getData(
        "WTAX_H",
        `Ref_PAY_ID = ${fromDatabase.Pay_Id}`
      );
      if (!getWtaxHResponse || getWtaxHResponse.length === 0) {
        console.warn("ไม่พบข้อมูล WTAX_H สำหรับ Pay_Id:", fromDatabase.Pay_Id);
      }
      setSelectedOption(getWtaxHResponse.at(0)?.WTAX_Type);
      const wtaxDResponses = await Promise.all(
        getWtaxHResponse.map(async (wtaxH) => {
          const wtaxId = wtaxH.WTAX_Id;
          return await getData(
            "WTAX_D",
            `WTax_Id = ${wtaxId} ORDER BY "WTAXDT_ID" ASC`
          );
        })
      );

      // ใช้ `flatMap()` แปลงข้อมูล WTAX_D รวมกันทั้งหมด
      const updatedTaxData = wtaxDResponses.flatMap((wtaxDData, index) =>
        wtaxDData.map((item, idx) => ({
          id: index * 100 + idx + 1, // ป้องกัน `id` ซ้ำกัน
          type: item?.WTAX_TypeNo || "",
          percent: item?.WTAX_Percent || 0,
          date: item?.WTAX_Date
            ? moment(item.WTAX_Date).format("YYYY/MM/DD")
            : "",
          amount: item?.WTAX_Pay || 0.0,
          tax: item?.WTAX_Tax || 0,
          remark: item?.WTAX_Desc || "",
        }))
      );

      // อัปเดต state
      setTaxData(updatedTaxData);
      setTotalWT(fromDatabase?.Total_WT);
      setDisTotal(fromDatabase?.Total_Dis_Footer);
      setInputValueTotalWT(parseCurrency(fromDatabase?.Total_WT));
      setInputValuedisTotal(parseCurrency(fromDatabase?.Total_Dis_Footer));
      setFormMasterList([
        {
          ...mapDatabaseToFormMasterList(fromDatabase),
          apName:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Name
              : fromViewAp.AP_Name,
          apAdd1:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add1
              : fromViewAp.AP_Add1,
          apAdd2:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add2
              : fromViewAp.AP_Add2,
          apAdd3:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Add3
              : fromViewAp.AP_Add3,
          apProvince:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Province
              : fromViewAp.AP_Province,
          apZipcode:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_Zipcode
              : fromViewAp.AP_Zipcode,
          apTaxNo:
            fromDatabase.Pay_Type === 3
              ? fromViewAr.AR_TaxNo
              : fromViewAp.AP_TaxNo,

          amountPay: parseCurrency(fromDatabase.Total_Pay_Per),
        },
      ]);

      // ดึงข้อมูลใบแม่และใบลูก (งวดแรก จนถึง งวดอื่นๆ)
      const fromMaster = await getDataWithComp(
        "PAY_H",
        `AND Pay_Id = ${fromDatabase.Pay_Id} AND Ref_DocID IS NULL`
      );
      const fromSubMaster = await getDataWithComp(
        "PAY_H",
        `AND Ref_DocID = ${fromDatabase.Pay_Id}`
      );
      let totalPayPer = 0;
      if (fromMaster.length > 0) {
        // กรณีมีใบแม่
        // คำนวณ Total_Pay_Per ของลูก ๆ (เฉพาะที่ Pay_Status = 1)
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            if (fromSubMaster[i].Pay_Status !== 2) {
              totalPayPer += parseCurrency(fromSubMaster[i].Total_Pay_Per);
            }
          }
        }
        // รวม Total_Pay_Per จากใบแม่ แต่เฉพาะที่ Pay_Status = 1
        if (fromMaster[0].Pay_Status !== 2) {
          totalPayPer += parseCurrency(fromMaster[0].Total_Pay_Per);
        }
      } else {
        // กรณีใบลูก
        // ค้นหาใบแม่จาก Ref_DocID ของใบลูก และเอาแม่มาคำนวณด้วย
        const parentId = fromDatabase.Ref_DocID;
        const parentMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id = ${parentId} AND Ref_DocID IS NULL`
        );
        const parentSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Ref_DocID = ${parentMaster[0].Pay_Id}`
        );
        if (parentMaster.length > 0) {
          // รวม Total_Pay_Per จากใบลูก แต่เฉพาะที่ Pay_Status = 1
          if (parentSubMaster.length > 0) {
            for (let i = 0; i < parentSubMaster.length; i++) {
              if (parentSubMaster[i].Pay_Status !== 2) {
                totalPayPer += parseCurrency(parentSubMaster[i].Total_Pay_Per);
              }
            }
          }
          // รวม Total_Pay_Per จากใบแม่ แต่เฉพาะที่ Pay_Status = 1
          if (parentMaster[0].Pay_Status !== 2) {
            totalPayPer += parseCurrency(parentMaster[0].Total_Pay_Per);
          }
        }
      }

      // if (String(fromDatabase.Pay_Type) === "4") {
      //   setTotalPrice(totalPayPer);
      //   setGrandTotal(totalPayPer);
      //   setFinalTotal(totalPayPer);
      //   handleBlurTotalDis();
      // }

      // ตั้งค่า OutstandingBalance เป็นผลรวมที่ได้
      setOutstandingBalance(totalPayPer);

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByPayId(
        "PAY_D",
        fromDatabase.Pay_Id,
        `ORDER BY Item_Code ASC`
      );

      if (String(fromDatabase.Pay_Type) === "1" && fromDetail.length > 0) {
        const recSelected = fromDetail
          .map((detail) =>
            recDataList.find(
              (rec) => rec.Rec_ID === parseCurrency(detail.Rec_Id, 10)
            )
          )
          .filter(Boolean);
        await onRowSelectRec(recSelected);
      } else if (String(fromDatabase.Pay_Type) === "4" && fromDetail.length > 0) {
        const poSelected = fromDetail
          .map((detail) =>
            poDataList.find(
              (po) => po.Doc_ID === parseCurrency(detail.Rec_Id, 10)
            )
          )
          .filter(Boolean);
        await onRowSelectPo(poSelected);
      } else if (
        (String(fromDatabase.Pay_Type) === "2" ||
          String(fromDatabase.Pay_Type) === "3") &&
        fromDetail.length > 0
      ) {
        // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
        const createNewRow = (index, itemSelected) => {
          const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
          const itemPriceUnit =
            parseCurrency(itemSelected.Item_Price_Unit) || 0;
          const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
          let itemTotal = itemQty * itemPriceUnit;

          if (itemSelected.Item_DisType === 2) {
            itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
          } else {
            itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
          }

          return {
            ...payDetailModel(index + 1),
            recDtId: itemSelected.DT_Id,
            recId: itemSelected.Rec_ID,
            line: itemSelected.Line,
            itemId: itemSelected.Item_Id,
            recNo: itemSelected.Rec_No,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(itemQty),
            itemUnit: itemSelected.Item_Unit,
            itemPriceUnit: formatCurrency(itemPriceUnit),
            itemDiscount: formatCurrency(itemDiscount),
            itemDisType: String(itemSelected.Item_DisType),
            itemTotal,
            itemStatus: itemSelected.Item_Status,
            whId: itemSelected.WH_ID,
            whName: itemSelected.WH_Name,
            zoneId: itemSelected.Zone_ID,
            ltId: itemSelected.LT_ID,
            dsSeq: itemSelected.DS_SEQ,
            itemDesc: itemSelected.Item_Desc,
          };
        };

        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const mapDatabaseToFormMasterList = (database) => ({
    docRefType: database.Pay_Type,
    datePay: database.Doc_PayDate,
    amountPay: parseCurrency(database.Total_Pay_Per),
    payId: database.Pay_Id,
    payNo: database.Pay_No,
    payDate: database.Pay_Date || null,
    docDueDate: database.Doc_DueDate || null,
    docPayDate: database.Doc_PayDate || null,
    payStatus: parseCurrency(database.Pay_Status, 10),
    payType: database.Pay_Type,
    refDocID: database.Ref_DocID,
    refDoc: database.Ref_Doc,
    refDocDate: database.Ref_DocDate,
    compId: database.Comp_Id,
    refProjectID: database.Ref_ProjectID,
    refProjectNo: database.Ref_ProjectNo,
    transportType: database.Transport_Type,
    docRemark1: database.Doc_Remark1,
    docRemark2: database.Doc_Remark2,
    apID: database.AP_Id,
    apCode: database.AP_Code,
    arID: database.AR_Id,
    arCode: database.AR_Code,
    actionHold: database.Action_Hold,
    discountValue: database.Discount_Value,
    discountValueType: database.Discount_Value_Type,
    discountCash: database.Discount_Cash,
    discountCashType: database.Discount_Cash_Type,
    discountTransport: database.Discount_Transport,
    discountTransportType: database.Discount_Transport_Type,
    isVat: database.IsVat,
    docSEQ: database.Doc_SEQ,
    creditTerm: database.CreditTerm,
    creditTerm1Day: database.CreditTerm1Day,
    creditTerm1Remark: database.CreditTerm1Remark,
    creditTerm2Remark: database.CreditTerm2Remark,
    accCode: database.ACC_Code,
    empName: database.EmpName,
    createdDate: setCreateDateTime(database.Created_Date || null),
    createdByName: database.Created_By_Name,
    createdById: database.Created_By_Id,
    updateDate: setCreateDateTime(database.Update_Date || null),
    updateByName: database.Update_By_Name,
    updateById: database.Update_By_Id,
    approvedDate: setCreateDateTime(database.Approved_Date || null),
    approvedByName: database.Approved_By_Name,
    approvedById: database.Approved_By_Id,
    cancelDate: setCreateDateTime(database.Cancel_Date || null),
    cancelByName: database.Cancel_By_Name,
    cancelById: database.Cancel_By_Id,
    approvedMemo: database.Approved_Memo,
    printedStatus: database.Printed_Status,
    printedDate: setCreateDateTime(database.Printed_Date || null),
    printedBy: database.Printed_By,
  });

  const updateWtaxRecords = async (payId, taxData) => {
    try {
      let getWtaxIdResponse = await getDataWithComp(
        "WTAX_H",
        `AND Ref_PAY_ID = ${payId}`
      );

      // ถ้าไม่มี WTAX_H มาก่อน ให้สร้างใหม่
      if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
        console.log("❗ ไม่พบ WTAX_H จะสร้างใหม่...");

        for (const taxItem of taxData) {
          if (
            !taxItem.amount ||
            parseFloat(parseCurrency(taxItem.amount)) === 0
          ) {
            console.warn(
              "⚠ ข้ามการสร้าง WTAX_H เพราะ amount เป็น 0 หรือไม่ถูกต้อง",
              taxItem
            );
            continue;
          }

          const newWTaxNo = await getSpRunNumber("WT"); // สร้าง WTax_No ใหม่

          const wtaxHData = {
            WTax_No: newWTaxNo,
            Ref_Doc: maxPayNo,
            AP_Id: formMasterList[0].apID,
            Ref_PAY_ID: payId,
            WTax_Type: selectedOption,
            WTax_Total: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
            WTax_Total_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
            WTax_Created_Date: moment().add(7, "hours").toDate(),
            WTax_Created_By: window.localStorage.getItem("name"),
            Comp_Id: window.localStorage.getItem("company"),
            WTAX_Status: 1,
          };

          const insertWtaxHRes = await insertData(
            "WTAX_H",
            Object.keys(wtaxHData).join(", "),
            Object.values(wtaxHData)
          );

          if (insertWtaxHRes?.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถสร้าง WTAX_H ใหม่ได้");
            return;
          }

          // ดึง WTAX_Id ที่สร้างขึ้น
          getWtaxIdResponse = await getDataWithComp(
            "WTAX_H",
            `AND WTax_No = '${newWTaxNo}'`
          );
        }
      }

      // อัปเดตข้อมูล WTAX_H ที่มีอยู่
      for (const [index, wtaxH] of getWtaxIdResponse.entries()) {
        if (index >= taxData.length) {
          console.warn(
            `❗ ไม่มี taxData สำหรับ WTax_Id: ${wtaxH.WTAX_Id}, ข้ามการอัปเดต`
          );
          continue;
        }

        const wtaxId = wtaxH.WTAX_Id;
        const relevantTaxItem = taxData[index];

        if (
          !relevantTaxItem ||
          parseFloat(parseCurrency(relevantTaxItem.amount || 0)) === 0
        ) {
          console.warn(
            `⚠ ข้ามการ insertData WTAX_D เพราะ amount เป็น 0 หรือข้อมูลไม่ถูกต้อง`,
            relevantTaxItem
          );
          continue;
        }

        const wtaxHData = {
          Ref_Doc: maxPayNo,
          AP_Id: formMasterList[0].apID,
          Ref_PAY_ID: payId,
          WTax_Type: selectedOption,
          WTax_Total: parseFloat(parseCurrency(relevantTaxItem.amount)).toFixed(
            2
          ),
          WTax_Total_Tax: parseFloat(
            parseCurrency(relevantTaxItem.tax)
          ).toFixed(2),
          WTax_Updated_Date: moment().add(7, "hours").toDate(),
          WTax_Updated_By: window.localStorage.getItem("name"),
        };

        await updateData("WTAX_H", wtaxHData, { WTax_Id: wtaxId });
        await deleteData("WTAX_D", `WHERE WTax_Id = ${wtaxId}`);

        const wtaxDData = {
          WTax_Id: wtaxId,
          WTax_TypeNo: relevantTaxItem.type,
          WTax_Desc: relevantTaxItem.remark || "",
          WTax_Percent: parseFloat(parseCurrency(relevantTaxItem.percent)),
          WTax_Date: relevantTaxItem.date
            ? moment(relevantTaxItem.date).add(7, "hours").toDate()
            : moment().add(7, "hours").toDate(),
          WTax_Pay: parseFloat(parseCurrency(relevantTaxItem.amount)).toFixed(
            2
          ),
          WTax_Tax: parseFloat(parseCurrency(relevantTaxItem.tax)).toFixed(2),
        };

        try {
          const insertResult = await insertData(
            "WTAX_D",
            Object.keys(wtaxDData).join(", "),
            Object.values(wtaxDData)
          );
        } catch (error) {
          console.error("❌ insertData ล้มเหลว:", error);
        }
      }
    } catch (error) {
      getAlert("FAILED", "เกิดข้อผิดพลาดในการอัปเดต WTAX");
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (
        (parseCurrency(docRefType) === 1 || parseCurrency(docRefType) === 2) &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      if (
        parseCurrency(docRefType) === 3 &&
        !formMasterList[0].arID &&
        !formMasterList[0].arCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบว่ามีการเลือกวันที่ครบทุกงวดหรือไม่ และ ต้องห้ามเป็นวันเดียวกัน
      let dateSet = new Set();
      for (let i = 0; i < formMasterList.length; i++) {
        if (!formMasterList[i].datePay) {
          getAlert("FAILED", "กรุณาเลือกวันที่จ่ายงวดที่ " + (i + 1));
          return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ไม่มีการเลือกวันที่
        }

        if (formMasterList[i].datePay) {
          let datePay = formMasterList[i].datePay;

          // ตรวจสอบวันที่จ่าย ต้องห้ามเป็นวันเดียวกัน
          if (dateSet.has(datePay)) {
            getAlert(
              "FAILED",
              "วันที่จ่ายงวดที่ " +
              (i + 1) +
              " ซ้ำกับวันที่จ่ายในงวดก่อนหน้านี้"
            );
            return; // หยุดการทำงานของฟังก์ชันหากวันที่ซ้ำ
          }

          dateSet.add(datePay);
        }
      }

      // ใบจ่าย Set วันที่ชำระ แต่ละใบเป็นวันที่ใบรับ ที่น้อยที่สุด + CreditTerm (ดักเฉพาะกรณีที่บันทึกใบจ่ายด้วยใบรับ)
      let newDocDueDate = formMasterList[0].docDueDate;

      const primaryPayNo = await getSpRunNumber("PAY");
      if (!primaryPayNo) {
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      // เก็บข้อมูลสำหรับใบแรกไว้เสมอ เช่น Ref_DocID, Ref_Doc, Ref_DocDate
      let refDocID = null;
      let refDoc = primaryPayNo;
      let refDocDate = formMasterList[0].payDate || null;

      // บันทึก formMasterList[0] ก่อน
      const formData = {
        pay_no: primaryPayNo,
        pay_date: formMasterList[0].payDate,
        doc_due_date: newDocDueDate
          ? newDocDueDate
          : moment().utcOffset(7, true).format("YYYY-MM-DD HH:mm:ss.SSS"),
        doc_pay_date: formMasterList[0].datePay,
        pay_status: parseCurrency("1", 10),
        pay_type: parseCurrency(docRefType, 10),
        ref_doc_id: null,
        ref_doc: null,
        ref_doc_date: null,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList[0].refProjectID,
        ref_project_no: formMasterList[0].refProjectNo,
        transport_type: formMasterList[0].transportType,
        doc_remark1: formMasterList[0].docRemark1,
        doc_remark2: formMasterList[0].docRemark2,
        ap_id: formMasterList[0].apID,
        ap_code: formMasterList[0].apCode,
        ar_id: formMasterList[0].arID,
        ar_code: formMasterList[0].arCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList[0].discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList[0].discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList[0].discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency("0", 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList[0].creditTerm1Remark,
        credit_term_2_remark: formMasterList[0].creditTerm2Remark,
        acc_code: "0000",
        emp_name: null,
        created_date: formatThaiDateUiToDate(formMasterList[0].createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        cancel_memo: null,
        total_pay_per: truncateToTwoDecimals(parseCurrency(formMasterList[0].amountPay)),
        total_wt: totalWT,
        isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
          ? "Y"
          : "N",
        total_dis_footer: parseCurrency(disTotal),
        total_pay_netTotal: truncateToTwoDecimals(parseCurrency(formMasterList[0].amountPay)),
      };

      const firstResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-pay-h`,
        formData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (firstResponse.data.status !== "OK") {
        getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลรายการแรกได้");
        return;
      }

      // Fetch ข้อมูลสำหรับ Ref_DocID
      const getPayIdResponse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/get-by-pay-no`,
        {
          table: "PAY_H",
          pay_no: primaryPayNo,
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // เก็บ Pay_Id ของใบแรกเอาไว้ใน refDocID และทำการบันทึก Detail ของใบแรกไปก่อน
      if (getPayIdResponse && getPayIdResponse.data.length > 0) {
        refDocID = getPayIdResponse.data[0].Pay_Id;

        const detailPromises = formDetailList.map(async (item, index) => {
          let payId = parseCurrency(getPayIdResponse.data[0].Pay_Id, 10);

          const formDetailData = {
            pay_id: payId,
            rec_dt_id: item.recDtId,
            rec_id: item.recId,
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype:
              item.itemDisType === "1"
                ? parseCurrency("1", 10)
                : parseCurrency("2", 10),
            item_total: parseCurrency(item.itemTotal),
            item_status: parseCurrency("1", 10),
            wh_id: parseCurrency(item.whId, 10),
            zone_id: parseCurrency("1", 10),
            lt_id: parseCurrency("1", 10),
            ds_seq: formatDateTime(new Date()),
            item_desc: item.itemDesc,
            emp_dept: item.empDept ? parseCurrency(item.empDept, 10) : (item.Emp_Dept ? parseCurrency(item.Emp_Dept, 10) : (getDeptFromItem(item) ? parseCurrency(getDeptFromItem(item), 10) : null)),
          };

          // ยอดสถานะค้างจ่ายของใบรับสินค้า
          if (String(formData.pay_type) === "1") {
            await updateStatusByNo(
              "REC_H", // table: ชื่อตาราง
              "Doc_Status_Paid", // field: ชื่อฟิลด์
              1, // status: สถานะที่ต้องการอัพเดท
              `WHERE Rec_ID = '${item.recId}'` // where: เงื่อนไขในการอัพเดท
            );
          } else if (String(formData.pay_type) === "4") {
            await updateStatusByNo(
              "PO_H", // table: ชื่อตาราง
              "Doc_Status_Paid", // field: ชื่อฟิลด์
              2, // status: สถานะที่ต้องการอัพเดท
              `WHERE Doc_Id = '${item.recId}'` // where: เงื่อนไขในการอัพเดท
            );
          }

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);
      } else {
        console.error("ไม่สามารถรับข้อมูล Pay_Id ได้");
        return;
      }

      // *********************************************************************************************
      // ถ้า formMasterList มีมากกว่า 1 ข้อมูล และให้เริ่มต้นบันทึกแต่ข้อมูลที่ [1] เป็นต้นไป
      if (formMasterList.length > 1) {
        for (let i = 1; i < formMasterList.length; i++) {
          // ใบจ่าย Set วันที่ชำระ แต่ละใบเป็นวันที่ใบรับ ที่น้อยที่สุด + CreditTerm (ดักเฉพาะกรณีที่บันทึกใบจ่ายด้วยใบรับ)
          // if (parseCurrency(docRefType) === 1) {
          //     // สมมติว่า `minReceiptDate` คือวันที่ใบรับที่น้อยที่สุด
          //     let minReceiptDate = newDocDueDate;

          //     // แปลงวันที่ไทยให้เป็นวันที่ที่ Moment เข้าใจ
          //     let minDateMoment = moment(minReceiptDate, 'DD-MM-YYYY');

          //     // เพิ่ม CreditTerm เข้าไปในวันที่ใบรับที่น้อยที่สุด
          //     newDocDueDate = minDateMoment.add(creditTerm, 'days').format('DD-MM-YYYY');
          // }

          // บันทึก Master
          let formMasterData = formMasterList[i];

          // // หาค่าสูงสุดของ PayNo ใน PAY_H ก่อนบันทึก
          // let dateString = formMasterList[i].datePay;
          // let givenDate =
          //   "PAY" +
          //   dateString.substring(6, 10).substring(2) +
          //   dateString.substring(3, 5);
          // const findMaxPayNo = await getDataWithComp(
          //   "PAY_H",
          //   `AND Pay_No LIKE '${givenDate}%' ORDER BY Pay_No DESC`
          // );
          // const maxPay = getMaxPayNo(findMaxPayNo, dateString);
          // let incrementedPayNo = maxPay;

          // คำนวณ YearMonth (พ.ศ.) ตามวันที่ชำระของงวดนั้นๆ
          const nextPayNo = await getSpRunNumber("PAY");
          if (!nextPayNo) {
            getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
            return;
          }

          // บันทึกรายการที่เหลือใน formMasterList
          let formData = {
            pay_no: nextPayNo,
            pay_date: formMasterData.payDate,
            doc_due_date: formMasterData.datePay,
            doc_pay_date: formMasterData.datePay,
            pay_status: parseCurrency("1", 10),
            pay_type: parseCurrency(docRefType, 10),
            ref_doc_id: refDocID,
            ref_doc: refDoc,
            ref_doc_date: refDocDate,
            comp_id: window.localStorage.getItem("company"),
            ref_project_id: formMasterData.refProjectID,
            ref_project_no: formMasterData.refProjectNo,
            transport_type: formMasterData.transportType,
            doc_remark1: formMasterData.docRemark1,
            doc_remark2: formMasterData.docRemark2,
            ap_id: formMasterData.apID,
            ap_code: formMasterData.apCode,
            ar_id: formMasterData.arID,
            ar_code: formMasterData.arCode,
            action_hold: parseCurrency("0", 10),
            discount_value: parseCurrency(formMasterData.discountValue || 0.0),
            discount_value_type: parseCurrency(selectedDiscountValueType, 10),
            discount_cash: parseCurrency("0.00"),
            discount_cash_type: formMasterData.discountCashType,
            discount_transport: parseCurrency("0.00"),
            discount_transport_type: formMasterData.discountTransportType,
            is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
            doc_seq: formatDateTime(new Date()),
            credit_term: parseCurrency("0", 10),
            credit_term_1_day: parseCurrency("0", 10),
            credit_term_1_remark: formMasterData.creditTerm1Remark,
            credit_term_2_remark: formMasterData.creditTerm2Remark,
            acc_code: "0000",
            emp_name: null,
            created_date: formatThaiDateUiToDate(formMasterData.createdDate),
            created_by_name: window.localStorage.getItem("name"),
            created_by_id: window.localStorage.getItem("emp_id"),
            update_date: null,
            update_by_name: null,
            update_by_id: null,
            approved_date: null,
            approved_by_name: null,
            approved_by_id: null,
            cancel_date: null,
            cancel_by_name: null,
            cancel_by_id: null,
            approved_memo: null,
            printed_status: "N",
            printed_date: null,
            printed_by: null,
            cancel_memo: null,
            total_pay_per: parseCurrency(formMasterData.amountPay),
            total_wt: totalWT,
            isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
              ? "Y"
              : "N",
            total_dis_footer: parseCurrency(disTotal),
            total_pay_netTotal: parseCurrency(formMasterData.amountPay),
          };

          let additionalResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-pay-h`,
            formData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (additionalResponse.data.status !== "OK") {
            getAlert("FAILED", "ไม่สามารถบันทึกรายการที่เหลือได้");
            return;
          }

          let getPayIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-pay-no`,
            {
              table: "PAY_H",
              pay_no: nextPayNo,
              comp_id: window.localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (getPayIdResponse && getPayIdResponse.data.length > 0) {
            // let detailPromises = formDetailList.map((item, index) => {
            //   let payId = parseCurrency(getPayIdResponse.data[0].Pay_Id, 10);

            //   let formDetailData = {
            //     pay_id: payId,
            //     rec_dt_id: item.recDtId,
            //     rec_id: item.recId,
            //     line: index + 1,
            //     item_id: item.itemId,
            //     item_code: item.itemCode,
            //     item_name: item.itemName,
            //     item_qty: parseCurrency(item.itemQty),
            //     item_unit: item.itemUnit,
            //     item_price_unit: parseCurrency(item.itemPriceUnit),
            //     item_discount: parseCurrency(item.itemDiscount),
            //     item_distype:
            //       item.itemDisType === "1"
            //         ? parseCurrency("1", 10)
            //         : parseCurrency("2", 10),
            //     item_total: parseCurrency(item.itemTotal),
            //     item_status: item.itemStatus,
            //     wh_id: parseCurrency(item.whId, 10),
            //     zone_id: parseCurrency("1", 10),
            //     lt_id: parseCurrency("1", 10),
            //     ds_seq: formatDateTime(new Date()),
            //     item_desc: item.itemDesc,
            //   };

            //   console.debug("formDetailData : ", formDetailData);

            //   return Axios.post(
            //     `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
            //     formDetailData,
            //     {
            //       headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            //     }
            //   );
            // });

            // await Promise.all(detailPromises);

            const detailPromises = formDetailList.map(async (item, index) => {
              let payId = parseCurrency(getPayIdResponse.data[0].Pay_Id, 10);

              const formDetailData = {
                pay_id: payId,
                rec_dt_id: item.recDtId,
                rec_id: item.recId,
                line: index + 1,
                item_id: item.itemId,
                item_code: item.itemCode,
                item_name: item.itemName,
                item_qty: parseCurrency(item.itemQty),
                item_unit: item.itemUnit,
                item_price_unit: parseCurrency(item.itemPriceUnit),
                item_discount: parseCurrency(item.itemDiscount),
                item_distype:
                  item.itemDisType === "1"
                    ? parseCurrency("1", 10)
                    : parseCurrency("2", 10),
                item_total: parseCurrency(item.itemTotal),
                item_status: parseCurrency("1", 10),
                wh_id: parseCurrency(item.whId, 10),
                zone_id: parseCurrency("1", 10),
                lt_id: parseCurrency("1", 10),
                ds_seq: formatDateTime(new Date()),
                item_desc: item.itemDesc,
                emp_dept: item.empDept ? parseCurrency(item.empDept, 10) : (item.Emp_Dept ? parseCurrency(item.Emp_Dept, 10) : (getDeptFromItem(item) ? parseCurrency(getDeptFromItem(item), 10) : null)),
              };

              // ยอดสถานะค้างจ่ายของใบรับสินค้า
              if (String(formData.pay_type) === "1") {
                await updateStatusByNo(
                  "REC_H", // table: ชื่อตาราง
                  "Doc_Status_Paid", // field: ชื่อฟิลด์
                  1, // status: สถานะที่ต้องการอัพเดท
                  `WHERE Rec_ID = '${item.recId}'` // where: เงื่อนไขในการอัพเดท
                );
              } else if (String(formData.pay_type) === "4") {
                await updateStatusByNo(
                  "PO_H", // table: ชื่อตาราง
                  "Doc_Status_Paid", // field: ชื่อฟิลด์
                  2, // status: สถานะที่ต้องการอัพเดท
                  `WHERE Doc_Id = '${item.recId}'` // where: เงื่อนไขในการอัพเดท
                );
              }

              return Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
                formDetailData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            });

            await Promise.all(detailPromises);
          }
        }
      }

      if (selectedFiles.length > 0) {
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/upload-file`,
            {
              comp_id: window.localStorage.getItem("company"),
              doc_id: getPayIdResponse.data[0].Pay_Id,
              DocCode_ID: 4,
              upload_by: window.localStorage.getItem("name"),
              file_status: "Y",
              files: selectedFiles.map((file) => file),
              doc_no_ref: null,
            }
          );
          if (response.data.status !== "SUCCESS") {
            getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
          }
        } catch (error) {
          getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
        }
      }

      const validTaxData = taxData.filter(
        (item) => parseCurrency(item.amount) > 0
      );

      if (validTaxData.length === 0) {
        callInitialize();
        getAlert("OK", "บันทึกข้อมูลสำเร็จ");
        // getAlert("FAILED", "ไม่มีข้อมูลที่สามารถสร้าง WTAX_H ได้");
        return;
      }

      for (const taxItem of validTaxData) {
        const newWTaxNo = await getSpRunNumber("WT"); // สร้าง WTax_No ใหม่สำหรับแต่ละใบ

        const wtaxHData = {
          WTax_No: newWTaxNo,
          Ref_PAY_ID: refDocID,
          AP_Id: formMasterList[0].apID,
          Ref_Doc: maxPayNo,
          WTax_Type: selectedOption,
          WTax_Total: parseCurrency(taxItem.amount).toFixed(2), // ทศนิยมเข้า DB
          WTax_Total_Tax: parseCurrency(taxItem.tax).toFixed(2),
          WTax_Created_Date: moment().add(7, "hours").toDate(),
          WTax_Created_By: window.localStorage.getItem("name"),
          WTax_Updated_Date: null,
          WTax_Updated_By: null,
          Comp_Id: window.localStorage.getItem("company"),
          WTAX_Status: 1,
        };

        const insertWtaxHRes = await insertData(
          "WTAX_H",
          Object.keys(wtaxHData).join(", "),
          Object.values(wtaxHData)
        );

        if (insertWtaxHRes?.status !== "OK") {
          getAlert(
            "FAILED",
            "ไม่สามารถบันทึกข้อมูลภาษีหัก ณ ที่จ่าย (WTAX_H) ได้"
          );
          return;
        }

        // ดึง WTAX_Id ที่สร้างขึ้น
        const getWtaxIdResponse = await getDataWithComp(
          "WTAX_H",
          `And WTax_No = '${newWTaxNo}'`
        );

        if (!getWtaxIdResponse || getWtaxIdResponse.length === 0) {
          getAlert("FAILED", "ไม่พบ WTax_Id ที่ถูกสร้างขึ้น");
          return;
        }

        const wtaxId = getWtaxIdResponse[0].WTAX_Id;

        // บันทึก WTAX_D สำหรับ WTAX_H แต่ละใบ

        const wtaxDData = {
          WTax_Id: wtaxId,
          WTax_TypeNo: taxItem.type,
          WTax_Desc: taxItem.remark || "",
          WTax_Percent: parseCurrency(taxItem.percent),
          WTax_Date: moment(taxItem.date).format("YYYY/MM/DD"),
          WTax_Pay: parseFloat(parseCurrency(taxItem.amount)).toFixed(2),
          WTax_Tax: parseFloat(parseCurrency(taxItem.tax)).toFixed(2),
        };

        const insertWtaxDRes = await insertData(
          "WTAX_D",
          Object.keys(wtaxDData).join(", "),
          Object.values(wtaxDData)
        );

        if (insertWtaxDRes?.status !== "OK") {
          getAlert("FAILED", "ไม่สามารถบันทึกข้อมูล WTAX_D ได้");
          return;
        }
      }

      callInitialize();
      getAlert("OK", "บันทึกข้อมูลสำเร็จ");
    } catch (error) {
      console.debug(error);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (
        (parseCurrency(docRefType) === 1 || parseCurrency(docRefType) === 2) &&
        !formMasterList[0].apID &&
        !formMasterList[0].apCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }
      if (
        parseCurrency(docRefType) === 3 &&
        !formMasterList[0].arID &&
        !formMasterList[0].arCode
      ) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบว่ามีการเลือกวันที่ครบทุกงวดหรือไม่
      for (let i = 0; i < formMasterList.length; i++) {
        if (!formMasterList[i].datePay) {
          getAlert("FAILED", "กรุณาเลือกวันที่จ่ายงวดที่ " + (i + 1));
          return; // หยุดการทำงานของฟังก์ชันหากมีงวดที่ไม่มีการเลือกวันที่
        }
      }

      const formMasterData = {
        pay_no: maxPayNo,
        pay_date: formMasterList[0].payDate,
        doc_due_date: formMasterList[0].docDueDate,
        doc_pay_date: formMasterList[0].datePay,
        pay_status: parseCurrency("1", 10),
        pay_type: parseCurrency(docRefType, 10),
        ref_doc_id: formMasterList[0].refDocID,
        ref_doc: formMasterList[0].refDoc,
        ref_doc_date: formMasterList[0].refDocDate,
        comp_id: formMasterList[0].compId,
        ref_project_id: formMasterList[0].refProjectID,
        ref_project_no: formMasterList[0].refProjectNo,
        doc_remark1: formMasterList[0].docRemark1,
        doc_remark2: formMasterList[0].docRemark2,
        ap_id: parseCurrency(formMasterList[0].apID, 10),
        ap_code: formMasterList[0].apCode,
        ar_id: parseCurrency(formMasterList[0].arID, 10),
        ar_code: formMasterList[0].arCode,
        action_hold: parseCurrency(formMasterList[0].actionHold, 10),
        discount_value: parseCurrency(formMasterList[0].discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency(formMasterList[0].discountCash),
        discount_cash_type: formMasterList[0].discountCashType,
        discount_transport: parseCurrency(formMasterList[0].discountTransport),
        discount_transport_type: formMasterList[0].discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formMasterList[0].docSEQ,
        credit_term: parseCurrency(formMasterList[0].creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList[0].creditTerm1Day, 10),
        credit_term_1_remark: formMasterList[0].creditTerm1Remark,
        credit_term_2_remark: formMasterList[0].creditTerm2Remark,
        acc_code: formMasterList[0].accCode,
        emp_name: formMasterList[0].empName,
        created_date: formatThaiDateUiToDate(formMasterList[0].createdDate),
        created_by_name: formMasterList[0].createdByName,
        created_by_id: formMasterList[0].createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        cancel_memo: null,
        total_pay_per: parseCurrency(formMasterList[0].amountPay),
        total_wt: totalWT,
        isWTAX: taxData.some((item) => parseCurrency(item.amount) > 0)
          ? "Y"
          : "N",
        total_dis_footer: parseCurrency(disTotal),
        total_pay_netTotal: parseCurrency(formMasterList[0].amountPay),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-pay-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // #####################################
      // DELETE PAY_D เฉพาะรายการเดียว
      const payId = parseCurrency(formMasterList[0].payId, 10);
      await deleteData("PAY_D", `WHERE Pay_Id = ${payId}`);
      // #####################################

      const detailPromises = formDetailList.map((item, index) => {
        const formDetailData = {
          pay_id: payId,
          rec_dt_id: item.recDtId,
          rec_id: item.recId,
          line: index + 1,
          item_id: item.itemId,
          item_code: item.itemCode,
          item_name: item.itemName,
          item_qty: parseCurrency(item.itemQty),
          item_unit: item.itemUnit,
          item_price_unit: parseCurrency(item.itemPriceUnit),
          item_discount: parseCurrency(item.itemDiscount),
          item_distype:
            item.itemDisType === "1"
              ? parseCurrency("1", 10)
              : parseCurrency("2", 10),
          item_total: parseCurrency(item.itemTotal),
          item_status: parseCurrency("1", 10),
          wh_id: parseCurrency(item.whId, 10),
          zone_id: parseCurrency("1", 10),
          lt_id: parseCurrency("1", 10),
          ds_seq: formatDateTime(new Date()),
          item_desc: item.itemDesc,
        };

        return Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-pay-d`,
          formDetailData,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );
      });
      await Promise.all(detailPromises);

      await updateWtaxRecords(payId, taxData);

      if (selectedFiles.length > 0) {
        try {
          const filteredFiles = selectedFiles.filter((file) => {
            // กรองไฟล์เก่าออกทั้งหมด (URL และ filename string)
            if (typeof file === "string") {
              return false; // ไม่อัพโหลดไฟล์เก่า (ทั้ง URL และ filename)
            }
            // อัพโหลดเฉพาะไฟล์ใหม่ที่เป็น Object
            return file && typeof file === "object" && file.isPending;
          });

          if (filteredFiles.length > 0) {
            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/upload-file`,
              {
                comp_id: window.localStorage.getItem("company"),
                doc_id: formMasterList[0].payId,
                DocCode_ID: 4,
                upload_by: window.localStorage.getItem("name"),
                file_status: "Y",
                files: filteredFiles,
                doc_no_ref: null,
              }
            );

            if (response.data.status !== "SUCCESS") {
              getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
            }
          }
        } catch (error) {
          getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
        }
      }

      // UPDATE ยอดล่าสุด
      if (docRefType === "4") {
        await updateStatusByNo(
          "PAY_H", // table: ชื่อตาราง
          "Total_Pay_Per", // field: ชื่อฟิลด์
          parseCurrency(formMasterList[0].amountPay), // status: สถานะที่ต้องการอัพเดท
          `WHERE Comp_Id = ${window.localStorage.getItem("company")} AND Pay_No = '${maxPayNo}'` // where: เงื่อนไขในการอัพเดท
        );
      }

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // Flow ยกเลิกใหม่จากพี่แบงค์ ระบบต้อง Auto ยกเลิกใบลูก หรือ ที่เกี่ยวข้องกับการจ่ายเป็นงวดทั้งหมด
      // ยกเว้นสถานะที่มีการจ่ายไปแล้ว จะไม่ทำอะไร
      if (formMasterList[0].refDoc !== null) {
        // ใบลูก => ต้องค้นหาเพื่อนๆ และแม่
        const fromMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id = ${formMasterList[0].refDocID} AND Ref_DocID IS NULL`
        );
        const fromSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Pay_Id <> ${formMasterList[0].payId} AND Ref_DocID = ${formMasterList[0].refDocID}`
        );

        // ตรวจสอบว่าพบข้อมูลจาก fromMaster หรือไม่
        if (fromMaster.length > 0 && fromMaster[0].Pay_Status === 1) {
          let formMasterData = {
            pay_no: fromMaster[0].Pay_No,
            pay_status: parseCurrency("13", 10),
            cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
            cancel_by_name: window.localStorage.getItem("name"),
            cancel_by_id: window.localStorage.getItem("emp_id"),
            comp_id: window.localStorage.getItem("company"),
          };
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
            formMasterData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // หยอด Item_Status = 0 ด้วย
          await handleCancelDetail(fromMaster[0].Pay_Id);
        }

        // ตรวจสอบว่าพบข้อมูลจาก fromSubMaster หรือไม่
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            if (fromSubMaster[i].Pay_Status === 1) {
              let formSubMasterData = {
                pay_no: fromSubMaster[i].Pay_No,
                pay_status: parseCurrency("13", 10),
                cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
                cancel_by_name: window.localStorage.getItem("name"),
                cancel_by_id: window.localStorage.getItem("emp_id"),
                comp_id: window.localStorage.getItem("company"),
              };
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
                formSubMasterData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );

              // หยอด Item_Status = 0 ด้วย
              await handleCancelDetail(fromSubMaster[i].Pay_Id);
            }
          }
        }
      } else {
        // ใบแม่ => ค้นหาแค่ลูกๆ
        const fromSubMaster = await getDataWithComp(
          "PAY_H",
          `AND Ref_DocID = ${formMasterList[0].payId}`
        );

        // ตรวจสอบว่าพบข้อมูลจาก fromSubMaster หรือไม่
        if (fromSubMaster.length > 0) {
          for (let i = 0; i < fromSubMaster.length; i++) {
            // เพิ่มดักเงื่อนไขว่า ต้องเป็นสถานะรอจ่ายเท่านั้น
            if (fromSubMaster[i].Pay_Status === 1) {
              let formSubMasterData = {
                pay_no: fromSubMaster[i].Pay_No,
                pay_status: parseCurrency("13", 10),
                cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
                cancel_by_name: window.localStorage.getItem("name"),
                cancel_by_id: window.localStorage.getItem("emp_id"),
                comp_id: window.localStorage.getItem("company"),
              };
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
                formSubMasterData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );

              // หยอด Item_Status = 0 ด้วย
              await handleCancelDetail(fromSubMaster[i].Pay_Id);
            }
          }
        }
      }

      // นอกนั้นคือการยกเลิกใบที่ onRowSelect
      const formMasterData = {
        pay_no: maxPayNo,
        pay_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-pay-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // หยอด Item_Status = 0 ด้วย
      await handleCancelDetail(formMasterList[0].payId);

      // ถ้าเป็นจ่ายล่วงหน้า ให้ทำการหยอดสถานะย้อนด้วย
      // คืนสถานะเอกสารอ้างอิงทั้งหมดที่เกี่ยวข้องกับใบสำคัญจ่ายนี้
      if (docRefType === "4") {
        for (const d of formDetailList) {
          await updateStatusByNo(
            "PO_H",
            "Doc_Status_Paid",
            1,
            `WHERE Doc_Id = '${d.recId}'`
          );
        }
      }

      if (docRefType === "1") {
        // ใช้ null เพื่อคืนค่าเป็นยังไม่ทำรายการ (NULL)
        for (const d of formDetailList) {
          await updateStatusByNo(
            "REC_H",
            "Doc_Status_Paid",
            0,
            `WHERE Rec_Id = '${d.recId}'`
          );
        }
      }

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancelDetail = async (payId) => {
    await updateQty(
      "PAY_D",
      `Item_Status = '${parseCurrency("0", 10)}'`,
      `WHERE Pay_Id = ${payId}`
    );
  };

  // Upload File
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedRecFiles, setSelectedRecFiles] = useState([]);
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };

  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedFiles((prev) => [...prev, e.target?.result]);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleBeforeUploadAttach = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setOpenUploadAttach(true);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงใน formDetailList
  const handleChangeDetail = (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value) && field !== "itemDesc") {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];

    // ดักเงื่อนไขว่า ถ้าเป็นจ่ายด้วยใบมัดจำ จะต้องใส่ itemQty ไม่เกินจำนวนของ itemQty ใบมัดจำ
    if (
      docRefType === "3" &&
      field === "itemQty" &&
      parseCurrency(value, 10) >
      parseCurrency(updatedList[index].itemOldQty, 10)
    ) {
      updatedList[index][field] = parseCurrency(
        updatedList[index].itemOldQty,
        10
      );
      setFormDetailList(updatedList);
      getAlert("FAILED", "ไม่สามารถรับสินค้าเกินกว่าสินค้าในใบมัดจำได้");
      return;
    }

    updatedList[index][field] = value;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocusMaster = (index, field) => {
    const updatedList = [...formMasterList];
    // กำหนดค่าเริ่มต้นถ้า field เป็น undefined
    const value = updatedList[index][field] || 0;
    updatedList[index][field] = parseCurrency(
      value.toString().replace(/,/g, "")
    );
    setFormMasterList(updatedList);
  };

  const handleBlurMaster = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formMasterList];
    updatedList[index][field] = formattedValue;
    setFormMasterList(updatedList);

    if (docRefType === "4") {
      handleBlurTotalDis();
    }
  };

  const handleFocusDetail = (index, field) => {
    const updatedList = [...formDetailList];
    // กำหนดค่าเริ่มต้นถ้า field เป็น undefined
    const value = updatedList[index][field] || 0;
    updatedList[index][field] = parseCurrency(
      value.toString().replace(/,/g, "")
    );
    setFormDetailList(updatedList);
  };

  const handleBlurDetail = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);
    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงใน formMasterList (action สำหรับตาราง)
  const handleChangeMasterList = (index, field, value) => {
    // ตรวจสอบว่า field เป็น 'amountPay' และค่าที่กรอกเข้ามาเป็นตัวเลขหรือไม่
    if (field === "amountPay" && !/^\d*\.?\d*$/.test(value)) {
      // แจ้งเตือนหากไม่ใช่ตัวเลข
      // getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    // if (field === "amountPay" && docRefType === "4") {
    //   const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    //   setTotalPrice(numericValue);
    //   setGrandTotal(numericValue);
    //   setFinalTotal(numericValue);
    // }

    const updatedList = [...formMasterList];
    updatedList[index][field] = value;
    setFormMasterList(updatedList);
  };

  const handleChangeDateMasterList = (value, name, index) => {
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    const updatedList = [...formMasterList];
    updatedList[index][name] = newValue;
    setFormMasterList(updatedList);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของเอกสารอ้างอิง
  const handleChangePayType = (value) => {
    const newPayMasterModel = [payMasterModel()];
    setFormMasterList(newPayMasterModel);
    setFormDetailList([]);
    setTotalPrice(0);
    setReceiptDiscount(0);
    setSubFinal(0);
    setGrandTotal(0);
    setFinalTotal(0);
    setIsVatChecked(false);
    setVatAmount(0);
    setDocRefType(value);
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของสถานะจ่าย
  const handlePaymentStatusChange = (status) => {
    // เก็บค่าของ formMasterList ที่มีอยู่เดิม
    const currentList = formMasterList[0]
      ? formMasterList[0]
      : payMasterModel();

    // เก็บค่า ap ข้อมูลไว้ก่อน
    const apData = {
      apID: currentList.apID,
      apCode: currentList.apCode,
      apName: currentList.apName,
      apAdd1: currentList.apAdd1,
      apAdd2: currentList.apAdd2,
      apAdd3: currentList.apAdd3,
      apProvince: currentList.apProvince,
      apZipcode: currentList.apZipcode,
      apTaxNo: currentList.apTaxNo,
    };

    if (status === "oneTime") {
      // ตั้งค่าให้กับรายการเดียว โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0
      setFormMasterList([
        {
          ...currentList,
          amountPay: formatCurrency(grandTotal),
          docRemark1: "",
          docRemark2: "",
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        },
      ]);
      setInstallmentCount(1); // ย้ายการตั้งค่ามาหลังจากกำหนด formMasterList แล้ว
    } else {
      // สร้างรายการตามจำนวน installmentCount โดยไม่เคลียร์ datePay
      const newList = Array.from({ length: installmentCount }, (v, i) => {
        let amountPay = (grandTotal / installmentCount).toFixed(2);
        if (i === installmentCount - 1) {
          amountPay = (grandTotal - amountPay * (installmentCount - 1)).toFixed(
            2
          );
        }
        return {
          ...payMasterModel(),
          amountPay: formatCurrency(amountPay),
          docRemark1: "",
          docRemark2: "",
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        };
      });
      // ตั้งค่าให้กับ formMasterList โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0 และแทนที่ค่าใหม่
      newList[0] = currentList;
      setFormMasterList(newList);
    }

    setPaymentStatus(status); // ย้ายการตั้งค่ามาหลังจากกำหนด formMasterList แล้ว
  };

  // ฟังก์ชันสำหรับจัดการการเปลี่ยนแปลงของจำนวนงวด
  const handleInstallmentCountChange = (value) => {
    if (!/^\d*$/.test(value) || value === "" || value === "0") return 1; // ตรวจสอบว่าเป็นตัวเลขเท่านั้น

    const count = parseCurrency(value, 10); // แปลงค่าจาก string เป็น number

    if (count > 100) {
      getAlert(
        "FAILED",
        "คุณไม่สามารถกำหนดจำนวนงวดเกิน 100 งวดได้ กรุณากรอกค่าใหม่อีกครั้ง"
      );
      return 1;
    }

    // เก็บค่าของ formMasterList ที่มีอยู่เดิม
    const currentList = formMasterList[0]
      ? formMasterList[0]
      : payMasterModel();

    // เก็บค่า ap ข้อมูลไว้ก่อน
    const apData = {
      docDueDate: currentList.docDueDate, // ถ้าเป็นการสร้างใบจ่ายด้วยใบรับสินค้า
      apID: currentList.apID,
      apCode: currentList.apCode,
      arID: currentList.arID,
      arCode: currentList.arCode,
      apName:
        parseCurrency(docRefType) === 3
          ? currentList.arName
          : currentList.apName,
      apAdd1: currentList.AP_Add1,
      apAdd2: currentList.AP_Add2,
      apAdd3: currentList.AP_Add3,
      apProvince: currentList.AP_Province,
      apZipcode: currentList.AP_Zipcode,
      apTaxNo: currentList.AP_TaxNo,
    };

    // สร้าง default model ที่ใช้เป็นค่าเริ่มต้น
    const defaultModel = payMasterModel();

    // คำนวณ amountPay สำหรับแต่ละงวด
    const installmentAmount = (grandTotal / count).toFixed(2);
    let newList = Array.from({ length: count }, (v, i) => {
      let amountPay = installmentAmount;
      if (i === count - 1) {
        amountPay = (grandTotal - installmentAmount * (count - 1)).toFixed(2);
      }
      return {
        ...defaultModel,
        datePay: i === 0 ? currentList.datePay : null, // datePay จะไม่เป็น null เฉพาะรายการแรก
        amountPay: formatCurrency(parseCurrency(amountPay)),
        docRemark1: "", // เคลียร์ค่าเฉพาะที่ต้องการ
        docRemark2: "", // เคลียร์ค่าเฉพาะที่ต้องการ
        ...apData, // ตั้งค่า ap ข้อมูลกลับไป
      };
    });

    setInstallmentCount(count); // ตั้งค่าจำนวนงวด
    setFormMasterList(newList); // อัปเดต formMasterList
  };

  // SET REC
  const [showRecModal, setShowRecModal] = useState(false);
  const handleRecShow = () => setShowRecModal(true);
  const handleRecClose = () => setShowRecModal(false);
  const onRowSelectRec = async (recSelected) => {
    try {
      const hasVat = recSelected.find((rec) => rec.IsVat === 1);
      const hasNoVat = recSelected.find((rec) => rec.IsVat === 0);

      if (hasVat && hasNoVat) {
        getAlert(
          "FAILED",
          "ไม่สามารถเลือกใบรับสินค้าที่มี VAT และไม่มี VAT ร่วมกันได้"
        );
        return;
      }

      // ค้นหาข้อมูลที่ตรงกับ recSelected.Rec_No ใน REC_H และ AP_ID ใน apDataList
      const [getAllRecH, getAllItem] = await Promise.all([
        getDataWithComp("API_0301_REC_H", "ORDER BY Rec_No DESC"),
        getDataWithComp("API_0302_REC_D", "ORDER BY Line ASC"),
      ]);

      // *** เช็คเฉพาะใบรับที่ค้างจ่าย DocStatusPaid = 1 (ค้างจ่าย) เท่านั้น ***
      const unpaidRec = recSelected.find((rec) => rec.Doc_Status_Paid === 1);

      if (unpaidRec) {
        recSelected = [unpaidRec]; // เก็บเฉพาะรายการที่พบใน recSelected

        const resultsPayD = await getData(
          "PAY_D",
          `Rec_Id = ${unpaidRec.Rec_ID}`
        );

        if (resultsPayD && resultsPayD.length > 0) {

          // ติดปัญหาเรื่อง Rec_Id 27 => 21 มาด้วย (AND PayStatus_Name <> 'ยกเลิก') 
          // กรณ๊ยกเิลกแล้ว ดึงใบที่ยกเลิกที่ผุกกับ Rec_Id มาใช้อีกรอบ
          const resultsRecPay = await getData(
            "API_0402_PAY_D",
            `Pay_Id = ${resultsPayD[0].Pay_Id} AND Item_Status = 1 AND PayStatus_Name <> 'ยกเลิก'`
          );
          if (resultsRecPay && resultsRecPay.length > 0) {
            // เคลียร์รายการทั้งหมดใน recSelected ก่อน
            recSelected.length = 0;

            // เก็บยอดเงินรวมไว้เพื่อไป +- กับใบที่จ่ายแล้ว
            let outstandingBalance = grandTotal;

            resultsRecPay.forEach((result) => {
              // กรองข้อมูลจาก getAllRecH โดยใช้ result.Rec_Id
              let filteredRec = getAllRecH.find(
                (rec) =>
                  parseCurrency(rec.Rec_ID) === parseCurrency(result.Rec_Id)
              );

              if (filteredRec) {
                // เพิ่มข้อมูลทั้งหมดใน filteredRec เข้าไปใน recSelected (ป้องกันซ้ำ)
                if (!recSelected.some((r) => r.Rec_ID === filteredRec.Rec_ID)) {
                  recSelected.push(filteredRec);
                }

                // สร้าง Set เพื่อเก็บ Rec_ID ที่ไม่ซ้ำกัน
                const uniqueRecIds = new Set(
                  recSelected.map((rec) => rec.Rec_ID)
                );

                // แสดงข้อความเฉพาะเมื่อมี Rec_ID ที่ไม่ซ้ำกันมากกว่า 1
                if (uniqueRecIds.size > 1) {
                  // getAlert("INFO", "เนื่องจากใบรับที่เลือกได้เคยถูกสร้างเป็นใบจ่ายร่วมกับใบรับอื่น ระบบจะทำการดึงข้อมูลให้อัตโนมัติ");
                }

                // ถ้า Doc_Status_Paid = 2 แสดงว่าจ่ายแล้ว ต้องลบ filteredRec.NetTotal จาก outstandingBalance
                if (filteredRec.Doc_Status_Paid === 2) {
                  setIsPayContinue(true);
                  outstandingBalance -= filteredRec.NetTotal;
                }
              }
            });
          }
        }
      }

      // ใช้ Set เพื่อหลีกเลี่ยงการค้นหาซ้ำ
      const recNoSet = new Set(recSelected.map((rec) => rec.Rec_No));
      const recNoArray = Array.from(recNoSet);

      const createNewRow = (index, itemSelected) => {
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;

        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }

        return {
          ...payDetailModel(index + 1),
          recDtId: itemSelected.DT_Id,
          recId: itemSelected.Rec_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          recNo: itemSelected.Rec_No,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal: formatCurrency(itemTotal, true),
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: null,
          empDept: getDeptFromItem(itemSelected),
          Emp_Dept: getDeptFromItem(itemSelected),
        };
      };

      // สร้างฟังก์ชันสำหรับการดึงข้อมูลของแต่ละ Rec_No
      const fetchDetailsForRecNo = async (recNo) => {
        const filterItem = getAllItem.filter((item) => item.Rec_No === recNo);
        const fromViewRecH = getAllRecH.find((po) => po.Rec_No === recNo);

        if (!fromViewRecH) {
          throw new Error(`ไม่พบข้อมูล REC_H สำหรับ Rec_No: ${recNo}`);
        }

        // การสร้างรายละเอียด
        if (filterItem.length > 0) {
          const newFormDetails = filterItem.map((item, index) =>
            createNewRow(index, item)
          );
          return { fromViewRecH, newFormDetails };
        } else {
          throw new Error(`ไม่พบข้อมูล REC_D สำหรับ Rec_No: ${recNo}`);
        }
      };

      // ดึงข้อมูลสำหรับ Rec_No ทั้งหมดใน recSelected
      const results = await Promise.all(
        recNoArray.map((recNo) => fetchDetailsForRecNo(recNo))
      );

      // รวมข้อมูลทั้งหมด
      const allDetails = results.flatMap((result) => result.newFormDetails);

      // // ดึงข้อมูล PO สำหรับการคำนวณส่วนลด
      const [getViewPoH] = await Promise.all([
        getDataWithComp("API_0201_PO_H", ""),
      ]);

      const calculateDiscountAndVat = (rec, isUpdateMode = false) => {
        const relatedPoH = getViewPoH.find((po) => po.Doc_ID === rec.Ref_DocID);

        if (relatedPoH) {
          // คำนวณส่วนลด
          if (relatedPoH.IsVat === 1) {
            setIsVatChecked(true);
          }
        }
      };

      recSelected.forEach((rec) => {
        calculateDiscountAndVat(rec, mode === "U");
      });

      // ตั้งค่า formDetailList
      setFormDetailList(allDetails);

      // หาวันที่ใบรับที่น้อยที่สุดจาก recSelected
      const minRecDate = Math.min(
        ...recSelected.map((rec) => new Date(rec.Rec_Date).getTime())
      );

      if (mode === "I") {
        // อัปเดต formMasterList สำหรับทุกรายการ
        setFormMasterList((prevState) =>
          prevState.map((item) => ({
            ...item,
            refDoc: "ใบรับสินค้าจำนวน " + recSelected.length + " ใบ",
            payDate: moment()
              .utcOffset(7, true)
              .format("YYYY-MM-DD HH:mm:ss.SSS"),
            docDueDate: moment(minRecDate),
            transportType: results[0].fromViewRecH.Transport_Type,
            apID: results[0].fromViewRecH.AP_ID,
            apCode: results[0].fromViewRecH.AP_Code,
            apName: results[0].fromViewRecH.AP_Name,
            apAdd1: results[0].fromViewRecH.AP_Add1,
            apAdd2: results[0].fromViewRecH.AP_Add2,
            apAdd3: results[0].fromViewRecH.AP_Add3,
            apProvince: results[0].fromViewRecH.AP_Province,
            apZipcode: results[0].fromViewRecH.AP_Zipcode,
            apTaxNo: results[0].fromViewRecH.AP_TaxNo,
            createdByName: window.localStorage.getItem("name"),
            createdDate: getCreateDateTime(),
            updateDate: results[0].fromViewRecH.Update_By_Name,
            updateByName: results[0].fromViewRecH.Update_Date,
            discountValueType: results[0].fromViewRecH.Discount_Value_Type,
            discountValue: results[0].fromViewRecH.Discount_Value,
          }))
        );
        let totalPrice = 0;
        let receiptDiscount = 0;
        let receiptVatAmount = 0;
        let uniquePOs = new Set();

        for (const recSelect of recSelected) {
          let getViewPoH = await getDataWithComp(
            "API_0201_PO_H",
            `AND Doc_ID = ${recSelect.Ref_DocID}`
          );

          if (getViewPoH.length > 0) {
            let poData = getViewPoH[0];
            uniquePOs.add(poData.Doc_ID);

            // ค้นหา Detail
            let getViewPoDetail = await getDataWithComp(
              "API_0202_PO_D",
              `AND Doc_ID = ${recSelect.Ref_DocID}`
            );
            for (const poDetail of getViewPoDetail) {
              totalPrice += poDetail.Item_Total;
              if (uniquePOs.size === 1) {
                receiptVatAmount = parseCurrency(
                  (poDetail?.SumVat || 0).toFixed(2)
                ); // กำหนดค่าเฉพาะกรณีที่ PO_H มีเพียงอันเดียว
              } else {
                receiptVatAmount += parseCurrency(
                  (poDetail?.SumVat || 0).toFixed(2)
                ); // บวกเพิ่มกรณีที่มีหลาย PO_H
              }
            }

            let discountAmount = 0;

            // ตรวจสอบประเภทส่วนลด
            if (poData.Discount_Value_Type === 1) {
              // ลดเป็นจำนวนเงิน
              discountAmount = poData.Discount_Value;
            } else if (poData.Discount_Value_Type === 2) {
              // ลดเป็นเปอร์เซ็นต์
              discountAmount = (totalPrice * poData.Discount_Value) / 100;
            }

            receiptDiscount += discountAmount;
          }

          // ค้นหาไฟล์ที่เกี่ยวข้อง (ปรับแต่งใหม่)
          if (recSelect.Rec_ID) {
            const image = await getDataWithComp(
              "Upload_File_List",
              `AND DocCode_ID = 3 AND Doc_ID = ${recSelect.Rec_ID}`
            );

            if (Array.isArray(image) && image.length > 0) {
              setSelectedRecFiles(image);
            } else {
              setSelectedRecFiles([]);
            }
          } else {
            setSelectedRecFiles([]);
          }
        }

        // setTotalPrice(totalPrice);
        // let receipt = receiptDiscount;
        // setReceiptDiscount(receipt);
        // setVatAmount(receiptVatAmount);
      }

      // ทำการเอาไปรับไปหาใบ PO ที่เคยจ่ายล่วงหน้าไปแล้ว
      const payDetailList = await getDataWithComp(
        "API_0402_PAY_D",
        `AND Pay_Type = 4 AND PayStatus_Name = 'จ่ายแล้ว' AND Rec_Id = ${recSelected[0].Ref_DocID}`
      );
      if (payDetailList && payDetailList.length > 0) {
        const prepayVal = parseCurrency(payDetailList[0].Total_Pay_Per) || 0;
        if (prepayVal > 0) {
          setPayBefore(prepayVal);
          setIsPayBefore(true);

          // แสดงยอดชำระล่วงหน้าในช่อง 'ส่วนลดท้ายใบจ่าย' แทนการใส่ใน receiptDiscount (เคสพี่แอม ขอมา)
          setDisTotal(prepayVal);
          setInputValuedisTotal(parseCurrency(prepayVal));
        }
      }

      handleRecClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const onConfirmRecSelection = async (recSelected) => {
    try {
      if (!recSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบรับสินค้า");
        return;
      }

      handleRecClose();

      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList([payMasterModel()]);
      setFormDetailList([]);
      setPaymentStatus("oneTime");
      setInstallmentCount(1);

      onRowSelectRec(recSelected);

      // แจ้งเตือนผู้ใช้ว่าการเลือกสำเร็จ
      getAlert("OK", "การเลือกใบรับสินค้าสำเร็จ");
    } catch (error) {
      console.error("Error in confirming receipt selection:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการเลือกใบรับสินค้า");
    }
  };

  // SET DEPOS
  const [showDeposModal, setShowDeposModal] = useState(false);
  const handleDeposShow = () => setShowDeposModal(true);
  const handleDeposClose = () => setShowDeposModal(false);
  const onRowSelectDepos = async (deposSelected) => {
    try {
      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList([payMasterModel()]);
      setFormDetailList([]);
      setPaymentStatus("oneTime");
      setInstallmentCount(1);

      // ค้นหารายการใบมัดจำ
      const [findDeposMaster] = await Promise.all([
        getDataWithComp("DEPOS_H", ""),
      ]);
      const fromDeposDatabase = findDeposMaster.find(
        (depos) => depos.Doc_No === deposSelected.Doc_No
      );

      if (!fromDeposDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...payDetailModel(index + 1),
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          recNo: itemSelected.Rec_No,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty,
          itemOldQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: null,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDeposDetail = await getByDocId(
        "DEPOS_D",
        fromDeposDatabase.Doc_Id,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );

      if (fromDeposDetail.length > 0) {
        const newFormDetails = fromDeposDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );
        setFormDetailList(newFormDetails);

        if (mode !== "U") {
          // อัปเดต formMasterList สำหรับทุกรายการ
          setFormMasterList((prevState) =>
            prevState.map((item) => ({
              ...item,
              payNo: maxPayNo,
              payDate: moment()
                .utcOffset(7, true)
                .format("YYYY-MM-DD HH:mm:ss.SSS"),
              docDueDate: moment()
                .utcOffset(7, true)
                .format("YYYY-MM-DD HH:mm:ss.SSS"),
              refDoc: deposSelected.Doc_No,
              refDocDate: deposSelected.Doc_Date || null,
              transportType: deposSelected.Transport_Type,
              arID: deposSelected.AR_ID,
              arCode: deposSelected.AR_Code,
              apName: deposSelected.AR_Name,
              discountValue: deposSelected.Discount_Value,
              discountValueType: deposSelected.Discount_Value_Type,
              isVat: deposSelected.IsVat,
              apAdd1: deposSelected.AR_Add1,
              apAdd2: deposSelected.AR_Add2,
              apAdd3: deposSelected.AR_Add3,
              apProvince: deposSelected.AR_Province,
              apZipcode: deposSelected.AR_Zipcode,
              apTaxNo: deposSelected.AR_TaxNo,
              printedStatus: deposSelected.Printed_Status,
            }))
          );
        }
      }

      handleDeposClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET PO
  const [showPoModal, setShowPoModal] = useState(false);
  const handlePoShow = () => setShowPoModal(true);
  const handlePoClose = () => setShowPoModal(false);
  const onRowSelectPo = async (poSelected) => {
    if (Array.isArray(poSelected)) {
      poSelected = poSelected[0];
    }
    if (!poSelected || typeof poSelected !== "object") return;
    try {
      const allPoHeaders = await getDataWithComp("API_0201_PO_H", "ORDER BY Doc_No DESC");
      const allPoDetails = await getDataWithComp("API_0202_PO_D", "AND Item_Status = 1 ORDER BY Line ASC");
      const poHeader = allPoHeaders.find(po => po.Doc_No === poSelected.Doc_No);
      if (!poHeader) throw new Error("ไม่พบข้อมูลหัวเอกสารใบสั่งซื้อ");

      const poDetails = allPoDetails.filter(
        item => item.Doc_No === poSelected.Doc_No
      );

      setDocNoPo(poHeader.Doc_No);

      let totalPrice = 0;
      let receiptDiscount = 0;
      let vatAmount = 0;
      let detailsRows = [];

      poDetails.forEach((item, idx) => {
        let itemQty = parseCurrency(item.Item_REC_Balance) || 0;
        let itemPriceUnit = parseCurrency(item.Item_Price_Unit) || 0;
        let itemDiscount = parseCurrency(item.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;
        if (item.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal;
        } else {
          itemTotal -= itemDiscount;
        }
        totalPrice += item.Item_Total;
        detailsRows.push({
          ...payDetailModel(idx + 1),
          recDtId: item.DT_Id,
          recId: item.Doc_ID,
          line: item.Line,
          itemId: item.Item_Id,
          itemCode: item.Item_Code,
          itemName: item.Item_Name,
          itemQty: formatCurrency(itemQty, true) || 0,
          itemRecBalance: formatCurrency(item.Item_REC_Balance, true) || 0,
          itemUnit: item.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType: String(item.Item_DisType),
          itemTotal: formatCurrency(itemTotal, true),
          itemGroup: item.Item_Group,
          itemStatus: item.Item_Status,
          whId: null,
          zoneId: item.Zone_ID,
          ltId: item.LT_ID,
          dsSeq: item.DS_SEQ,
          itemDesc: item.Item_Desc,
          docNo: poSelected.Doc_No
        });
      });

      let discountValue = parseCurrency(poHeader.Discount_Value || 0);
      if (poHeader.Discount_Value_Type === 1) {
        receiptDiscount = discountValue;
      } else if (poHeader.Discount_Value_Type === 2) {
        receiptDiscount = (totalPrice * discountValue) / 100;
      }

      const subFinal = parseCurrency(totalPrice) - parseCurrency(receiptDiscount);
      vatAmount = poHeader.IsVat === 1 ? subFinal * 0.07 : 0;
      const grandTotal = parseCurrency(subFinal) + parseCurrency(vatAmount);
      const finalTotal = parseCurrency(grandTotal) - parseCurrency(totalWT) - parseCurrency(disTotal);

      if (mode !== "U") {
        setFormMasterList([
          {
            ...formMasterList[0],
            refDocID: poHeader.Doc_ID,
            refDoc: poHeader.Doc_No,
            refDocDate: poHeader.Doc_Date,
            docDate: moment().utcOffset(7, true).format("YYYY-MM-DD HH:mm:ss.SSS"),
            docDueDate: moment().utcOffset(7, true).format("YYYY-MM-DD HH:mm:ss.SSS"),
            docRemark1: poHeader.Doc_Remark1,
            docRemark2: poHeader.Doc_Remark2,
            docType: poHeader.Doc_Type,
            docFor: poHeader.Doc_For,
            transportType: poHeader.Transport_Type,
            discountValue: poHeader.Discount_Value,
            discountValueType: poHeader.Discount_Value_Type,
            creditTerm: poHeader.CreditTerm,
            apID: poHeader.AP_ID,
            apCode: poHeader.AP_Code,
            apName: poHeader.AP_Name,
            apAdd1: poHeader.AP_Add1,
            apAdd2: poHeader.AP_Add2,
            apAdd3: poHeader.AP_Add3,
            apProvince: poHeader.AP_Province,
            apZipcode: poHeader.AP_Zipcode,
            apTaxNo: poHeader.AP_TaxNo,
            createdByName: window.localStorage.getItem("emp_name"),
            createdDate: getCreateDateTime(),
            updateDate: poHeader.Update_Date,
            updateByName: poHeader.Update_By_Name,
          }
        ]);
      }

      setFormDetailList(detailsRows);
      setTotalPrice(totalPrice);
      setReceiptDiscount(receiptDiscount);
      setSubFinal(subFinal);
      setVatAmount(vatAmount);
      setGrandTotal(grandTotal);
      setFinalTotal(finalTotal);

      setIsVatChecked(poHeader.IsVat === 1 ? true : false);

      if (!isNaN(poHeader.Discount_Value_Type)) {
        setSelectedDiscountValueType(poHeader.Discount_Value_Type.toString());
      }

      handlePoClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      // เก็บค่าของ formMasterList ที่มีอยู่เดิม
      const currentList = formMasterList[0]
        ? formMasterList[0]
        : payMasterModel();

      // เก็บค่า ap ข้อมูลไว้ก่อน
      const apData = {
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
      };

      // ตั้งค่าให้กับรายการเดียว โดยเก็บค่าเดิมไว้ที่ตำแหน่งที่ 0
      setFormMasterList([
        {
          ...currentList,
          ...apData, // ตั้งค่า ap ข้อมูลกลับไป
        },
      ]);

      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemDesc: null,
            empDept: selectedDeptInModal || null,
            Emp_Dept: selectedDeptInModal || null,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (docRefType !== "4") {
      const total = formDetailList.reduce(
        (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
        0
      );

      // ตรวจสอบชนิดของ amountPay และแปลงให้เหมาะสม
      let amountPay = formMasterList[0]?.amountPay; // ใช้ Optional Chaining เพื่อป้องกันข้อผิดพลาดกรณี formMasterList[0] ไม่มีค่า
      if (typeof amountPay === "string") {
        amountPay = parseCurrency(amountPay.replace(/,/g, "")) || 0;
      } else if (typeof amountPay === "number") {
        amountPay = amountPay || 0;
      } else {
        amountPay = 0; // ค่าเริ่มต้นในกรณีที่ไม่ใช่ string หรือ number
      }

      setTotalPrice(total);
    }
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList[0].discountValue || 0);
    let receiptDiscount = 0;
    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }
    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList[0].discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal) (ไม่ได้ใช้)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    if (docRefType === "2") {
      const vat = isVatChecked ? truncateTo2Decimals(subFinal * 0.07) : 0;
      setVatAmount(vat);
    } else if (docRefType === "1") {
      const vat = isVatChecked ? truncateTo2Decimals(subFinal * 0.07) : 0;
      setVatAmount(vat);
    }
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const calculatedGrandTotal = subFinal + vatAmount - totalWT;
    const calculatedFinalTotal = calculatedGrandTotal - disTotal;

    setGrandTotal(calculatedGrandTotal);
    setFinalTotal(calculatedFinalTotal);

    if (
      (parseCurrency(docRefType) === 1 && mode !== "U") ||
      (parseCurrency(docRefType) === 2 && formMasterList[0]?.payStatus === 1) ||
      (parseCurrency(docRefType) === 3 && mode !== "U")
    ) {
      if (mode === "I") {
        const formattedValue = formatCurrency(calculatedFinalTotal);
        setFormMasterList((prevList) => {
          const updatedList = [...prevList];
          if (updatedList.length > 0) {
            updatedList[0].amountPay = formattedValue;
          }
          return updatedList;
        });
      }
    }

  }, [subFinal, vatAmount, totalWT, disTotal]);

  useEffect(() => {
    if (docRefType !== "4") {
      if (formMasterList[0].payStatus === 1) {
        setOutstandingBalance(FinalTotal);
      } else {
        setOutstandingBalance(0.0);
      }
    }
  }, [grandTotal, outstandingBalance, FinalTotal]);

  const [showModalDatePicker, setShowModalDatePicker] = useState(false);
  const [selectedDateIndex, setSelectedDateIndex] = useState(null);

  const openModalDatePicker = (index) => {
    setSelectedDateIndex(index);
    setShowModalDatePicker(true);
  };

  const closeModalDatePicker = () => setShowModalDatePicker(false);

  useEffect(() => {
    if (docRefType !== "4") {
      let discountValue = parseCurrency(formMasterList[0]?.discountValue || 0);
      let calculatedDiscount = 0;

      if (selectedDiscountValueType === "2") {
        // ส่วนลดเป็นเปอร์เซ็นต์
        calculatedDiscount = (totalPrice * discountValue) / 100;
      } else if (selectedDiscountValueType === "1") {
        // ส่วนลดเป็นจำนวนเงิน
        calculatedDiscount = discountValue;
      }

      // ตรวจสอบค่าก่อนตั้งค่า
      if (!isNaN(calculatedDiscount) && calculatedDiscount !== receiptDiscount) {
        setReceiptDiscount(calculatedDiscount);
      }
    }
  }, [totalPrice, formMasterList[0]?.discountValue, selectedDiscountValueType]);

  const [showWTModal, setShowWTModal] = useState(false);
  const handleWTClose = () => setShowWTModal(false);
  const CalculationTotalWT = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = parseFloat(value) || 0;
      setTotalWT(numericValue);
      setInputValueTotalWT(value);
    }
  };

  const handleBlurTotalWT = () => {
    const numericValue =
      parseCurrency(inputValueTotalWT.replace(/,/g, "")) || 0;
    setTotalWT(numericValue);
    setInputValueTotalWT(
      numericValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    ); // ใส่ , คั่นหลักพัน
  };

  const handleFocusTotalWT = () => {
    setInputValueTotalWT(String(totalWT).replace(/,/g, ""));
  };

  const setdetailsTotalWT = () => {
    if (taxData.length === 0) {
      setTaxData([
        {
          id: 1,
          type: 5,
          percent: 3.0,
          date: currentDate,
          amount: 0.0,
          tax: 0.0,
          remark: "",
        },
        {
          id: 2,
          type: 6,
          percent: 3.0,
          date: currentDate,
          amount: 0.0,
          tax: 0.0,
          remark: "",
        },
      ]);
    }
    setShowWTModal(true);
  };

  const CalculationTotalDis = (event) => {
    const value = event.target.value.replace(/,/g, "");
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = parseCurrency(value) || 0;
      setDisTotal(numericValue);
      setInputValuedisTotal(value);
    }
  };

  const handleBlurTotalDis = () => {
    const numericValue = parseCurrency(inputValuedisTotal) || 0;
    setDisTotal(numericValue);
    setInputValuedisTotal(formatCurrency(numericValue));
  };

  const handleFocusTotalDis = () => {
    setInputValuedisTotal(String(disTotal).replace(/,/g, ""));
  };

  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={maxPayNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherTypeName={statusPaidTypeName}
        otherTypeColour={statusPaidTypeColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/payment-voucher" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => getReport("pay", formMasterList[0].payNo)}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        selectedRecFiles={selectedRecFiles}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={handleInputFileChange}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
        urlImg={formMasterList[0].docPaidPic}
        handleUploadSlip={handleUploadSlip}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
      />
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสาร"
              name="payDate"
              value={formMasterList[0]?.payDate}
              onChange={(date) =>
                handleChangeDateMasterList(date, "payDate", 0)
              }
              disabled={mode === "U"}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ผู้ขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList[0]?.apCode || "") +
                    " " +
                    (formMasterList[0]?.apName || "")
                  }
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleApShow}
                  disabled={
                    docRefType === "1" || docRefType === "3" || docRefType === "4" || mode === "U"
                      ? true
                      : false
                  }
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ApModal
              showApModal={showApModal}
              handleApClose={handleApClose}
              apDataList={apDataList}
              onRowSelectAp={onRowSelectAp}
            />
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList[0]?.createdDate}
                // onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label className="me-2">เอกสารอ้างอิง</label>
              <select
                name="payType"
                value={formMasterList[0]?.docRefType}
                className="form-select form-control input-spacing"
                onChange={(e) => handleChangePayType(e.target.value)}
                disabled={mode === "U"}
              >
                <option value="1">จ่ายตามใบรับสินค้า</option>
                <option value="2">จ่ายเฉพาะรายการ</option>
                <option value="3">จ่ายตามใบมัดจำ</option>
                <option value="4">จ่ายตามใบสั่งซื้อ (ล่วงหน้า)</option>
                <option value="5" disabled>
                  จ่ายตามใบแจ้งซ่อม
                </option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList[0]?.apAdd1 || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList[0]?.createdByName || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={docRefType === "4" ? docNoPo : formMasterList[0]?.refDoc || ""}
                  onChange={handleChangeMasterList}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleRecShow}
                  hidden={docRefType === "1" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleDeposShow}
                  hidden={docRefType === "3" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={handlePoShow}
                  hidden={docRefType === "4" ? false : true}
                  disabled={mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <RecModal
                showRecModal={showRecModal}
                handleRecClose={handleRecClose}
                recDataList={recDataList}
                onConfirmRecSelection={onConfirmRecSelection}
              />
              <DeposModal
                showDeposModal={showDeposModal}
                handleDeposClose={handleDeposClose}
                deposDataList={deposDataList}
                onRowSelectDepos={onRowSelectDepos}
              />
              <PoModal
                showPoModal={showPoModal}
                handlePoClose={handlePoClose}
                poDataList={poDataList}
                onRowSelectPo={onRowSelectPo}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList[0]?.apAdd2 || "") +
                  " " +
                  (formMasterList[0]?.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList[0]?.updateDate || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="กำหนดจ่าย"
              name="docDueDate"
              value={formMasterList[0]?.docDueDate}
              onChange={(date) =>
                handleChangeDateMasterList(date, "docDueDate", 0)
              }
              disabled={false}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList[0]?.apProvince || "") +
                  " " +
                  (formMasterList[0]?.apZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList[0]?.updateByName || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* {docRefType === "2" && (
              <div className="d-flex align-items-center">
                <label className="me-2">รูปแบบการจ่าย</label>
                <select
                  className="form-select form-control input-spacing"
                  value={paymentDeptType}
                  onChange={(e) => setPaymentDeptType(e.target.value)}
                  disabled={mode === "U"}
                >
                  <option value="1">จ่ายแผนกเดียว</option>
                  <option value="2">จ่ายหลายแผนก</option>
                </select>
              </div>
            )} */}
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList[0]?.apTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่อนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedDate"
                value={formMasterList[0]?.approvedDate || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMasterList}
                disabled={true}
                className="form-select form-control input-spacing"
              >
                {docRefType === "2" && (
                  <>
                    <option value="1">ซื้อมาเพื่อใช้</option>
                    <option value="2">ซื้อมาเพื่อขาย</option>
                  </>
                )}
              </select>
            </div> */}
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้อนุมัติเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={formMasterList[0]?.approvedByName || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-6" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>หมายเหตุอนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedMemo"
                value={formMasterList[0]?.approvedMemo || ""}
                onChange={handleChangeMasterList}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "summary" ? "active" : ""
                        }`}
                      onClick={() => handleTabChange("summary")}
                    >
                      ยอดรวม
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === "details" ? "active" : ""
                        }`}
                      onClick={() => handleTabChange("details")}
                    >
                      รายละเอียดสินค้า
                    </button>
                  </li>
                </ul>
              </div>
              {activeTab === "summary" ? (
                <div className="card-body">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-4">
                            <div>
                              <h4 className="card-title">ยอดท้ายบิล</h4>
                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-3">
                                      <label>สถานะจ่าย</label>
                                    </div>
                                    <div className="col-6">
                                      <div className="radio-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="paymentStatus"
                                          value="oneTime"
                                          checked={paymentStatus === "oneTime"}
                                          onChange={() =>
                                            handlePaymentStatusChange("oneTime")
                                          }
                                          disabled={mode === "U" || docRefType === "4"}
                                        />
                                        <label className="form-check-label">
                                          จ่ายครั้งเดียว
                                        </label>
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="paymentStatus"
                                          value="installment"
                                          checked={
                                            paymentStatus === "installment"
                                          }
                                          onChange={() =>
                                            handlePaymentStatusChange(
                                              "installment"
                                            )
                                          }
                                          disabled={mode === "U" || docRefType === "4"}
                                        />
                                        <label clPassName="form-check-label">
                                          จ่ายเป็นงวด
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      {paymentStatus === "installment" && (
                                        <input
                                          type="text"
                                          className="form-control text-end input-spacing"
                                          style={{ width: "100px" }}
                                          value={installmentCount}
                                          onChange={(e) =>
                                            handleInstallmentCountChange(
                                              e.target.value
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                  <div className="row mt-4">
                                    <div className="col-3">
                                      <label>รวมราคา</label>
                                    </div>
                                    <div className="col-9">
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        style={{ width: "100px" }}
                                        value={formatCurrency(totalPrice || 0)}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-4">
                                    <div className="col-3">
                                      <label>รวมส่วนลด</label>
                                    </div>
                                    <div className="col-9">
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        style={{ width: "100px" }}
                                        value={formatCurrency(receiptDiscount)}
                                        // onChange={(e) => {
                                        //   const value = e.target.value.replace(
                                        //     /[^0-9.]/g,
                                        //     ""
                                        //   );
                                        //   setReceiptDiscount(
                                        //     value ? parseFloat(value) : 0
                                        //   );
                                        // }}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                  <hr />
                                  <div className="row mt-2 align-items-center">
                                    <div className="col-3 d-flex align-items-center">
                                      {docRefType === "2" && (
                                        <input
                                          type="checkbox"
                                          className="me-2"
                                          checked={isVatChecked}
                                          onChange={handleVatChange}
                                          disabled={
                                            formMasterList[0]?.payStatus === 2
                                              ? true
                                              : false
                                          }
                                        />
                                      )}
                                      <label className="mb-0">VAT</label>
                                    </div>
                                    <div className="col-9">
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        value={formatCurrency(
                                          truncateTo2Decimals(
                                            vatAmount
                                          )
                                        )}
                                        disabled={true}
                                        style={{ width: "150px" }}
                                      />
                                    </div>
                                  </div>
                                  <hr />
                                  <div className="row mt-4">
                                    <div className="col-3">
                                      <label>
                                        <h5>หัก ณ ที่ จ่าย</h5>
                                      </label>
                                    </div>
                                    <div
                                      className="col-4"
                                      style={{ display: "flex" }}
                                    >
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        style={{
                                          width: "150px",
                                          // color: "red",
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                        value={inputValueTotalWT}
                                        onChange={CalculationTotalWT}
                                        onBlur={handleBlurTotalWT}
                                        onFocus={handleFocusTotalWT}
                                        disabled={
                                          (formMasterList.length > 0 && formMasterList[0]?.payStatus === 1)
                                            ? docRefType === "4" ? true : false
                                            : true
                                        }
                                      />
                                      <div class="input-group-append">
                                        <button
                                          onClick={
                                            () => setdetailsTotalWT()
                                          }
                                          class="btn btn-lg text-white"
                                          style={{
                                            padding: "15px",
                                            borderRadius: "0 5px 5px 0",
                                            backgroundColor: "#EF6C00",
                                            marginLeft: "-1px",
                                          }}
                                          type="button"
                                          disabled={docRefType === "4"}
                                        >
                                          +
                                        </button>
                                      </div>
                                      {taxData.length > 0 && taxData[0]?.amount !== 0.0 &&
                                        taxData.length !== 0 ? (
                                        <select
                                          className="form-control"
                                          value={selectedOption}
                                          disabled={true}
                                          style={{
                                            width: "150px",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          <option value={1}>
                                            (1) ภ.ง.ด.1ก.
                                          </option>
                                          <option value={2}>
                                            (2) ภ.ง.ด.1ก.พิเศษ
                                          </option>
                                          <option value={3}>(3) ภ.ง.ด.2</option>
                                          <option value={4}>(4) ภ.ง.ด.3</option>
                                          <option value={5}>
                                            (5) ภ.ง.ด.2ก.
                                          </option>
                                          <option value={6}>
                                            (6) ภ.ง.ด.3ก.
                                          </option>
                                          <option value={7}>
                                            (7) ภ.ง.ด.53
                                          </option>
                                        </select>
                                      ) : null}
                                      {/* <button onClick={() => getMaxWtaxNo()}>
                                        test
                                      </button> */}
                                      <WtaxModal
                                        showWTModal={showWTModal}
                                        handleWTClose={handleWTClose}
                                        apDataList={apDataList}
                                        setTotalWT={setTotalWT}
                                        setInputValueTotalWT={
                                          setInputValueTotalWT
                                        }
                                        selectedOption={selectedOption}
                                        setSelectedOption={setSelectedOption}
                                        taxData={taxData}
                                        setTaxData={setTaxData}
                                        setTaxtotalAmount={setTaxtotalAmount}
                                        formMasterList={formMasterList}
                                        setFormMasterList={setFormMasterList}
                                        docRef={docRef}
                                        setDocRef={setDocRef}
                                        Ref_PAY_ID={Ref_PAY_ID}
                                        setRef_PAY_ID={setRef_PAY_ID}
                                      // onRowSelectAp={onRowSelectAp}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mt-4">
                                    <div className="col-3">
                                      <label>
                                        <h5>รวมยอด</h5>
                                      </label>
                                    </div>
                                    <div className="col-4">
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        style={{
                                          width: "100px",
                                          color: "red",
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                        value={formatCurrency(grandTotal || 0)}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>

                                  <div className="row mt-4">
                                    <div className="col-3">
                                      <label>
                                        <h5>ส่วนลดท้ายใบจ่าย</h5>
                                      </label>
                                    </div>
                                    <div className="col-4">
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        style={{
                                          width: "100px",
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                        value={inputValuedisTotal}
                                        onChange={CalculationTotalDis}
                                        onBlur={handleBlurTotalDis}
                                        onFocus={handleFocusTotalDis}
                                        disabled={
                                          formMasterList[0].payStatus !== 1 || (docRefType === "4")
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="row mt-4">
                                    <div className="col-3">
                                      <label>
                                        <h5>รวมจ่ายสุทธิ</h5>
                                      </label>
                                    </div>
                                    <div className="col-4">
                                      <input
                                        type="text"
                                        className="form-control text-end input-spacing"
                                        style={{
                                          width: "100px",
                                          color: "red",
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                        value={formatCurrency(FinalTotal || 0)}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-8">
                            <div>
                              <div className="row mt-3">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                          <h4 className="card-title">
                                            ตารางจ่าย
                                          </h4>
                                          {isPayBefore && (
                                            <p style={{ color: 'red', fontWeight: 'bold', marginTop: '8px' }}>
                                              *** มีการชำระเงินล่วงหน้าไปแล้ว เป็นจำนวนเงิน {formatCurrency(payBefore)} บาท ****
                                            </p>
                                          )}
                                        </div>
                                        <div className="card-body">
                                          <div
                                            className="table-responsive"
                                            style={{
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                              zIndex: "1",
                                            }}
                                          >
                                            <table className="table table-striped table-hover">
                                              <thead className="thead-dark">
                                                <tr>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "2%" }}
                                                  >
                                                    #
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "18%" }}
                                                  >
                                                    วันที่จ่าย
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "18%" }}
                                                  >
                                                    จำนวนเงิน
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "31%" }}
                                                  >
                                                    รายละเอียดเอกสาร
                                                  </th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "31%" }}
                                                  >
                                                    หมายเหตุธุรการ
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {formMasterList.map(
                                                  (item, index) => (
                                                    <tr key={index + 1}>
                                                      <td className="text-center">
                                                        {index + 1}
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control text-center"
                                                          value={
                                                            item.datePay
                                                              ? formatDate(
                                                                item.datePay
                                                              )
                                                              : "เลือกวันที่"
                                                          }
                                                          onClick={() =>
                                                            openModalDatePicker(
                                                              index
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              .payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                      <td className="text-end">
                                                        <input
                                                          type="text"
                                                          className="form-control text-end input-spacing"
                                                          value={formatCurrency(
                                                            item.amountPay || 0
                                                          )}
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "amountPay",
                                                              e.target.value
                                                            )
                                                          }
                                                          onFocus={(e) =>
                                                            handleFocusMaster(
                                                              index,
                                                              "amountPay"
                                                            )
                                                          }
                                                          onBlur={(e) =>
                                                            handleBlurMaster(
                                                              index,
                                                              "amountPay",
                                                              e.target.value
                                                            )
                                                          }
                                                          onInput={(e) => {
                                                            if (
                                                              /^0+/.test(
                                                                e.target.value
                                                              )
                                                            ) {
                                                              e.target.value =
                                                                e.target.value.replace(
                                                                  /^0+/,
                                                                  ""
                                                                );
                                                            }
                                                          }}
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            item.docRemark1 ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "docRemark1",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              .payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          value={
                                                            item.docRemark2 ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleChangeMasterList(
                                                              index,
                                                              "docRemark2",
                                                              e.target.value
                                                            )
                                                          }
                                                          disabled={
                                                            formMasterList[0]
                                                              .payStatus !== 1
                                                          }
                                                        />
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>

                                            {/* Modal For DatePicker */}
                                            <div
                                              className={`modal fade ${showModalDatePicker
                                                ? "show"
                                                : ""
                                                }`}
                                              style={{
                                                display: showModalDatePicker
                                                  ? "block"
                                                  : "none",
                                              }}
                                              tabIndex="-1"
                                              role="dialog"
                                            >
                                              <div
                                                className="modal-dialog modal-dialog-centered modal-md"
                                                role="document"
                                              >
                                                <div className="modal-content">
                                                  <div
                                                    className="modal-header"
                                                    style={{
                                                      backgroundColor:
                                                        "#EF6C00",
                                                    }}
                                                  >
                                                    <h5 className="modal-title text-white">
                                                      เลือกวันที่
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      className="close"
                                                      onClick={
                                                        closeModalDatePicker
                                                      }
                                                    >
                                                      <span>&times;</span>
                                                    </button>
                                                  </div>
                                                  <div
                                                    className="modal-body"
                                                    style={{
                                                      backgroundColor:
                                                        "#F5F7FD",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      label="เลือกวันที่"
                                                      name="datePay"
                                                      value={
                                                        formMasterList[
                                                          selectedDateIndex
                                                        ]?.datePay || moment()
                                                      }
                                                      onChange={(date) => {
                                                        handleChangeDateMasterList(
                                                          date,
                                                          "datePay",
                                                          selectedDateIndex
                                                        );
                                                      }}
                                                      disabled={false}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-4" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card-body">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title">รายละเอียดสินค้า</h4>
                        <button
                          type="button"
                          className="btn text-white mx-3"
                          onClick={handleItemShow}
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "10px",
                            fontSize: "15px",
                          }}
                          hidden={
                            docRefType === "1" || docRefType === "3" || docRefType === "4"
                              ? true
                              : false
                          }
                          disabled={formMasterList[0].payStatus !== 1}
                        >
                          <i className="fa fa-plus"></i> เพิ่มรายการ
                        </button>
                      </div>
                      <ItemModal
                        formDetailList={formDetailList}
                        showItemModal={showItemModal}
                        handleItemClose={handleItemClose}
                        itemDataList={itemDataList}
                        onRowSelectItem={onRowSelectItem}
                        deptDataList={deptDataList}
                        purchaseType={null}
                        selectedDeptInModal={selectedDeptInModal}
                        setSelectedDeptInModal={setSelectedDeptInModal}
                      />
                      <div className="card-body">
                        <div
                          className="table-responsive"
                          style={{ maxHeight: "500px", overflowY: "auto" }}
                        >
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "2%" }}
                                >
                                  #
                                </th>
                                {(docRefType === "1" || docRefType === "4") && (
                                  <th
                                    className="text-center"
                                    style={{ width: "8%" }}
                                  >
                                    เลขที่เอกสาร {docRefType === "1" ? "(REC)" : "(PO)"}
                                  </th>
                                )}
                                <th
                                  className="text-center"
                                  style={{
                                    width: docRefType !== "1" ? "8%" : "6%",
                                  }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{
                                    width: docRefType === "1" || docRefType === "4" ? "16%" : "18%",
                                  }}
                                >
                                  ชื่อสินค้า
                                </th>

                                {docRefType === "2" && (
                                  <th
                                    className="text-center"
                                    style={{
                                      width: "18%",
                                    }}
                                  >
                                    หมายเหตุ
                                  </th>
                                )}

                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  จำนวน
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "6%" }}
                                >
                                  หน่วย
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  ราคาต่อหน่วย
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  ส่วนลด
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "5%" }}
                                >
                                  %
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  จำนวนเงินรวม
                                </th>
                                {docRefType === "2" && (
                                  <th
                                    className="text-center"
                                    style={{ width: "10%" }}
                                  >
                                    แผนก
                                  </th>
                                )}
                                {docRefType === "2" && (
                                  <th
                                    className="text-center"
                                    style={{ width: "3%" }}
                                  >
                                    ลบ
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {formDetailList
                                .sort((a, b) => a.line - b.line)
                                .map((item, index) => (
                                  <tr key={item.itemId || index + 1}>
                                    {/* # */}
                                    <td className="text-center">{index + 1}</td>

                                    {/* # RecNo */}
                                    <td
                                      hidden={docRefType === "1" ? false : true}
                                      className="text-center"
                                    >
                                      <span>{item.recNo || ""}</span>
                                    </td>

                                    {/* # PoNo */}
                                    <td
                                      hidden={docRefType === "4" ? false : true}
                                      className="text-center"
                                    >
                                      <span>{item.docNo || ""}</span>
                                    </td>

                                    {/* รหัสสินค้า */}
                                    <td className="text-center">
                                      <span>{item.itemCode || ""}</span>
                                    </td>

                                    {/* ชื่อสินค้า */}
                                    <td className="text-left">
                                      <span>{item.itemName || ""}</span>
                                    </td>

                                    {/* หมายเหตุ */}
                                    {docRefType === "2" && (
                                      <td className="text-left">
                                        <input
                                          type="text"
                                          className="form-control text-left"
                                          value={item.itemDesc || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDesc",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            formMasterList[0].payStatus !== 1
                                          }
                                        />
                                      </td>
                                    )}

                                    {/* จำนวน */}
                                    <td className="text-center">
                                      {docRefType === "1" || docRefType === "4" ? (
                                        <span>{item.itemQty || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-center"
                                          value={item.itemQty || 0}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemQty",
                                              e.target.value
                                            )
                                          }
                                          onFocus={(e) =>
                                            handleFocusDetail(index, "itemQty")
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemQty",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" || docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* หน่วย */}
                                    <td className="text-center">
                                      <span>{item.itemUnit || ""}</span>
                                    </td>

                                    {/* ราคาต่อหน่วย */}
                                    <td className="text-end">
                                      {docRefType === "1" ||
                                        docRefType === "3" || docRefType === "4" ? (
                                        <span>{item.itemPriceUnit || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-end"
                                          value={item.itemPriceUnit || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemPriceUnit",
                                              e.target.value
                                            )
                                          }
                                          onFocus={() =>
                                            handleFocusDetail(
                                              index,
                                              "itemPriceUnit"
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemPriceUnit",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* ส่วนลด */}
                                    <td className="text-end">
                                      {docRefType === "1" ||
                                        docRefType === "3"
                                        || docRefType === "4" ? (
                                        <span>{item.itemDiscount || 0}</span>
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control text-end"
                                          value={item.itemDiscount || 0}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDiscount",
                                              e.target.value
                                            )
                                          }
                                          onFocus={() =>
                                            handleFocusDetail(
                                              index,
                                              "itemDiscount"
                                            )
                                          }
                                          onBlur={(e) =>
                                            handleBlurDetail(
                                              index,
                                              "itemDiscount",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                          onInput={(e) => {
                                            if (/^0+/.test(e.target.value)) {
                                              e.target.value =
                                                e.target.value.replace(
                                                  /^0+/,
                                                  ""
                                                );
                                            }
                                          }}
                                        />
                                      )}
                                    </td>

                                    {/* % */}
                                    <td className="text-center">
                                      {docRefType === "1" ||
                                        docRefType === "3" || docRefType === "4" ? (
                                        <span>
                                          {item.itemDisType === "1"
                                            ? "฿"
                                            : item.itemDisType === "2"
                                              ? "%"
                                              : ""}
                                        </span>
                                      ) : (
                                        <select
                                          className="form-select"
                                          value={item.itemDisType || ""}
                                          onChange={(e) =>
                                            handleChangeDetail(
                                              index,
                                              "itemDisType",
                                              e.target.value
                                            )
                                          }
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                        >
                                          <option value="1">฿</option>
                                          <option value="2">%</option>
                                        </select>
                                      )}
                                    </td>

                                    {/* จำนวนเงินรวม */}
                                    <td className="text-end">
                                      <span>
                                        {formatCurrency(item.itemTotal || 0)}
                                      </span>
                                    </td>

                                    {docRefType === "2" && (
                                      <td className="text-center">
                                        {formMasterList[0].payStatus !== 1 ? (
                                          <span>
                                            {(() => {
                                              const deptId =
                                                item.empDept || item.Emp_Dept || getDeptFromItem(item);
                                              const dept = deptDataList.find(
                                                (d) => String(d.Dept_Id) === String(deptId)
                                              );
                                              return dept ? dept.Dept_Name : "";
                                            })()}
                                          </span>
                                        ) : (
                                          <select
                                            className="form-select"
                                            value={item.empDept || item.Emp_Dept || ""}
                                            onChange={(e) =>
                                              handleChangeDetail(index, "empDept", e.target.value)
                                            }
                                            disabled={formMasterList[0].payStatus !== 1}
                                          >
                                            <option value="">เลือกแผนก</option>
                                            {deptDataList.map((d) => (
                                              <option key={d.Dept_Id} value={d.Dept_Id}>
                                                {d.Dept_Name}
                                              </option>
                                            ))}
                                          </select>
                                        )}
                                      </td>
                                    )}

                                    {docRefType === "2" && (
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          onClick={() => handleRemoveRow(index)}
                                          disabled={
                                            docRefType === "1" ||
                                            docRefType === "3" ||
                                            docRefType === "4" ||
                                            formMasterList[0].payStatus !== 1
                                          }
                                        >
                                          ลบ
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <br />
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        setMode={setMode}
        disabled={formMasterList[0].payStatus !== 1}
        footer={true}
      />
    </>
  );
}

export default Form;
